var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 779.7 313.1",
    style: {
      enableBackground: "new 0 0 779.7 313.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D1BFAF;}\r\n\t.st1{fill:#605B55;}\r\n\t.st2{fill:#F3B15A;}\r\n\t.st3{clip-path:url(#SVGID_00000123413552921278431610000011390211626970078339_);}\r\n\t\r\n\t\t.st4{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_321_00000075154987793300622510000003309730872062335671_);}\r\n\t\r\n\t\t.st5{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_322_00000078742851476975958860000018055779352211250099_);}\r\n\t\r\n\t\t.st6{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_323_00000133505480837586183130000000333799342474348439_);}\r\n\t\r\n\t\t.st7{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_324_00000148641049739309847700000014672154263928444577_);}\r\n\t\r\n\t\t.st8{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_325_00000114057532845481148010000007071198219986378664_);}\r\n\t\r\n\t\t.st9{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_326_00000078016316060845763060000016301838915945784210_);}\r\n\t\r\n\t\t.st10{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_327_00000085953143497805171720000016244015560591088014_);}\r\n\t\r\n\t\t.st11{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_328_00000090973341322466551020000000633633435638896259_);}\r\n\t\r\n\t\t.st12{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_329_00000179618977923618189270000009190186556180126630_);}\r\n\t\r\n\t\t.st13{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_330_00000139983975405572348390000006434342519049440414_);}\r\n\t\r\n\t\t.st14{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_331_00000088826873319797320460000014112992588617915582_);}\r\n\t\r\n\t\t.st15{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_332_00000012436906076102392660000017257504806971176107_);}\r\n\t\r\n\t\t.st16{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_333_00000016766936023963769610000005538281057750946220_);}\r\n\t\r\n\t\t.st17{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_334_00000126308882688534222900000004928012087472851118_);}\r\n\t\r\n\t\t.st18{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_335_00000016057924541081138510000015243986510461490856_);}\r\n\t\r\n\t\t.st19{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_336_00000086690177324745490340000000131905023553072295_);}\r\n\t\r\n\t\t.st20{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_337_00000077322401803553807860000010550986750451820465_);}\r\n\t\r\n\t\t.st21{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_338_00000101100950624042933860000009496209810342750650_);}\r\n\t\r\n\t\t.st22{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_339_00000044137069030068310830000005839852928680556214_);}\r\n\t\r\n\t\t.st23{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_340_00000150066971590696993260000008156958338825243823_);}\r\n\t\r\n\t\t.st24{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_341_00000160163251847606860890000009635001985086923672_);}\r\n\t\r\n\t\t.st25{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_342_00000143592842290452231960000006224730743306263703_);}\r\n\t\r\n\t\t.st26{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_343_00000090257113355474149660000014322191941710674335_);}\r\n\t\r\n\t\t.st27{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_344_00000134965792458203072330000007474523313575775116_);}\r\n\t\r\n\t\t.st28{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_345_00000132802896924865909510000017727414740785611166_);}\r\n\t\r\n\t\t.st29{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_346_00000112614488577296615230000017259584209506640518_);}\r\n\t\r\n\t\t.st30{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_347_00000141416256118920666050000005987085808254753678_);}\r\n\t\r\n\t\t.st31{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_348_00000063610668964925052050000014829803158645433534_);}\r\n\t\r\n\t\t.st32{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_349_00000049183430977253813420000005846082617044994453_);}\r\n\t\r\n\t\t.st33{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_350_00000119092568868413727220000000681866960537958025_);}\r\n\t\r\n\t\t.st34{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_351_00000108301380798174295590000016008324363960193961_);}\r\n\t\r\n\t\t.st35{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_352_00000084515449400658279890000004242355308956194211_);}\r\n\t\r\n\t\t.st36{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_353_00000121983091383615864420000006564738076690924444_);}\r\n\t\r\n\t\t.st37{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_354_00000003090611778720595330000014751286643520289162_);}\r\n\t\r\n\t\t.st38{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_355_00000085239553954838498560000014976968410248402344_);}\r\n\t\r\n\t\t.st39{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_356_00000111871260877763717930000015492243109960051895_);}\r\n\t\r\n\t\t.st40{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_357_00000119804567487912930100000015769507636479294889_);}\r\n\t\r\n\t\t.st41{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_358_00000056400932495350205220000003142214911718395307_);}\r\n\t\r\n\t\t.st42{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_359_00000081636623363015060340000009006309459884115891_);}\r\n\t\r\n\t\t.st43{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_360_00000029020183324325192720000011527645912347369149_);}\r\n\t\r\n\t\t.st44{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_361_00000016049092942568449430000013680486987334307713_);}\r\n\t\r\n\t\t.st45{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_362_00000109031690776946216260000001440165882253200519_);}\r\n\t\r\n\t\t.st46{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_363_00000043454349950858412750000004009196687033299357_);}\r\n\t\r\n\t\t.st47{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_364_00000040553232169880600660000014754385278395466427_);}\r\n\t\r\n\t\t.st48{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_365_00000006706782838547033090000015057292724914315150_);}\r\n\t\r\n\t\t.st49{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_366_00000041983665987196775630000002062954490604520090_);}\r\n\t\r\n\t\t.st50{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_367_00000071521735993570903290000010939098833203405991_);}\r\n\t\r\n\t\t.st51{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_368_00000147189064159875488380000008909011220870024871_);}\r\n\t\r\n\t\t.st52{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_369_00000002384367582328030530000018425560022707215518_);}\r\n\t\r\n\t\t.st53{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_370_00000003809420195306274940000005875035116523317913_);}\r\n\t\r\n\t\t.st54{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_371_00000111892774688691987440000012707223054653849252_);}\r\n\t\r\n\t\t.st55{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_372_00000170957879167813851870000001890756349387082906_);}\r\n\t\r\n\t\t.st56{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_373_00000025428107286062786840000003548139088809933209_);}\r\n\t\r\n\t\t.st57{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_374_00000009570346145981955860000007233747266670347662_);}\r\n\t\r\n\t\t.st58{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_375_00000044154756510074840340000004371012449973658295_);}\r\n\t\r\n\t\t.st59{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_376_00000155824812976316775630000013693053771403379120_);}\r\n\t\r\n\t\t.st60{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_377_00000153664992165311874750000002777008424977240705_);}\r\n\t\r\n\t\t.st61{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_378_00000087401559208364032580000017390752851118534816_);}\r\n\t\r\n\t\t.st62{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_379_00000025416628262166672720000012152244747153126078_);}\r\n\t\r\n\t\t.st63{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_380_00000058567148170740951960000008696232615665695663_);}\r\n\t\r\n\t\t.st64{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_381_00000100367929818309752950000006090597282525611440_);}\r\n\t\r\n\t\t.st65{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_382_00000163751081789866184020000004821059660360990641_);}\r\n\t\r\n\t\t.st66{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_383_00000000941885528999565580000006509661284813731466_);}\r\n\t\r\n\t\t.st67{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_384_00000048495744515396872130000017022357130691746223_);}\r\n\t\r\n\t\t.st68{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_385_00000113320867271225760900000012128074083343639463_);}\r\n\t\r\n\t\t.st69{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_386_00000147935234087311522860000015876640261472185765_);}\r\n\t\r\n\t\t.st70{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_387_00000132084180210422826860000015455294104327853752_);}\r\n\t\r\n\t\t.st71{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_388_00000088855528965375545780000002170325011117834402_);}\r\n\t\r\n\t\t.st72{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_389_00000080185940646278191490000016828894618680330140_);}\r\n\t\r\n\t\t.st73{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_390_00000102544980482038183790000011089345075249077177_);}\r\n\t\r\n\t\t.st74{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill-rule:evenodd;clip-rule:evenodd;fill:url(#Trazado_391_00000115495352367395732390000012373194195916587179_);}\r\n\t\r\n\t\t.st75{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_392_00000075124916325681689530000010799062476174649517_);}\r\n\t\r\n\t\t.st76{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:url(#Trazado_393_00000130624051354839727580000014028731825733156524_);}\r\n\t\r\n\t\t.st77{clip-path:url(#SVGID_00000141423414361747959290000008557753728123751349_);fill:none;stroke:#724F2B;stroke-width:0.93;stroke-miterlimit:10;}\r\n\t.st78{clip-path:url(#SVGID_00000123413552921278431610000011390211626970078339_);fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.2,144.3c1.7-0.3,3.3-0.5,5-0.5c2.1,0,4.2,0.3,6.3,0.9c2,0.6,3.9,1.5,5.5,2.7s2.9,2.6,3.9,4.3 s1.4,3.6,1.4,5.7c0,1.9-0.4,3.6-1.3,5.2c-0.9,1.6-2,2.9-3.5,4s-3.2,2-5.3,2.6c-2,0.6-4.2,0.9-6.6,0.9c-2.8,0-5.4-0.3-7.9-0.9 c-2.5-0.6-5-1.4-7.2-2.5c-2.3-1.1-4.5-2.4-6.6-3.9s-4-3.2-5.8-5c-2.5,1.2-5.2,2.1-7.9,2.8c-2.8,0.7-5.7,1-8.7,1 c-3.7,0-6.8-0.4-9.5-1.2c-2.6-0.8-4.8-1.8-6.4-3.2c-1.6-1.4-2.9-2.9-3.6-4.6s-1.2-3.6-1.2-5.6c0-2.6,0.6-4.9,1.8-6.9 c1.2-2,2.8-3.8,4.8-5.4c2-1.6,4.3-3,6.9-4.2c2.6-1.2,5.4-2.4,8.2-3.5c-0.2-1.6-0.3-3.2-0.3-4.7c0-3.6,0.7-6.8,2-9.7 c1.3-2.9,3-5.4,5.2-7.4c2.1-2,4.5-3.6,7.1-4.7c2.6-1.1,5.3-1.7,7.9-1.7c1.7,0,3.2,0.2,4.6,0.7c1.4,0.5,2.6,1.1,3.5,2 c1,0.8,1.7,1.8,2.3,3s0.8,2.3,0.8,3.6c0,1.8-0.4,3.4-1.1,4.8s-1.8,2.7-3.1,3.9c-1.3,1.2-2.8,2.2-4.6,3.2c-1.7,1-3.6,1.9-5.6,2.7 s-4.1,1.6-6.3,2.4c-2.2,0.8-4.3,1.6-6.5,2.4c0.4,1.9,1,4,1.7,6.2c0.7,2.2,1.6,4.4,2.7,6.6c1,2.2,2.2,4.4,3.5,6.7 c1.3,2.2,2.8,4.3,4.3,6.3c2-1.2,3.8-2.5,5.4-4s3.1-3.1,4.2-4.7c1.1-1.6,2.1-3.4,2.8-5.2c0.7-1.8,1-3.6,1-5.4c0-1.4-0.1-2.5-0.4-3.3 c-0.2-0.8-0.4-1.4-0.4-1.6l2.6-0.7c0.1,0.4,0.3,1.1,0.5,2.1c0.2,1,0.3,2.2,0.3,3.6c0,1.9-0.3,3.8-1,5.8c-0.7,2-1.7,3.9-2.9,5.7 c-1.2,1.8-2.8,3.6-4.6,5.3c-1.8,1.7-3.8,3.2-5.9,4.6c1.5,1.8,3.1,3.5,4.8,5c1.7,1.5,3.5,2.8,5.4,3.9c1.9,1.1,3.8,2,5.8,2.6 s4,0.9,6.1,0.9c1.7,0,3.4-0.2,5-0.7c1.6-0.4,3-1.1,4.2-2c1.2-0.9,2.2-2.1,2.9-3.5c0.7-1.4,1.1-3.1,1.1-5.1c0-1.8-0.4-3.3-1.1-4.6 s-1.7-2.5-2.9-3.4c-1.2-0.9-2.6-1.6-4.1-2.1s-3.1-0.7-4.8-0.7c-0.7,0-1.4,0-2.1,0.1c-0.7,0.1-1.3,0.2-1.9,0.3L444.2,144.3z  M406.9,129.7c-2.2,0.9-4.2,1.9-6.1,3c-1.9,1.1-3.6,2.3-5,3.6s-2.5,2.8-3.4,4.5s-1.2,3.5-1.2,5.6c0,1.8,0.3,3.4,0.9,4.9 s1.5,2.8,2.7,3.9c1.2,1.1,2.8,2,4.7,2.6s4.2,0.9,6.8,0.9c2.3,0,4.7-0.3,7-0.8c2.3-0.5,4.6-1.3,6.8-2.2c-1.7-1.9-3.3-3.9-4.7-6.1 c-1.4-2.1-2.7-4.3-3.8-6.5s-2.1-4.5-2.8-6.7C407.9,134.2,407.3,131.9,406.9,129.7z M436.6,108.2c0-0.8-0.2-1.6-0.5-2.4 c-0.3-0.8-0.8-1.5-1.5-2.1c-0.7-0.6-1.5-1.1-2.6-1.5s-2.3-0.6-3.7-0.6c-1.9,0-3.9,0.4-5.9,1.1s-3.8,1.9-5.4,3.5s-2.9,3.7-3.9,6.2 s-1.5,5.6-1.5,9.1c0,0.6,0,1.1,0.1,1.7c0,0.6,0.1,1.2,0.2,1.8c3.1-1.1,6.2-2.2,9.2-3.3s5.6-2.3,7.9-3.6c2.3-1.3,4.2-2.8,5.6-4.4 C435.9,112.3,436.6,110.4,436.6,108.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M285.1,146.5c-2-1.4-3.6-2.8-4.7-4.4c-1.2-1.5-2-3.1-2.6-4.6c-0.6-1.5-1-3-1.1-4.5c-0.2-1.5-0.2-2.8-0.2-4 c0-2.1,0.2-4,0.6-5.7s0.9-3.2,1.6-4.6c0.7-1.4,1.4-2.5,2.3-3.5s1.8-1.8,2.8-2.5s1.9-1.2,2.9-1.5s1.9-0.5,2.7-0.5 c1.3,0,2.5,0.3,3.5,1c1.1,0.7,2,1.7,2.8,2.9c0.8,1.3,1.4,2.8,1.8,4.5s0.7,3.7,0.7,5.8c0,2.8-0.3,5.5-0.9,8.1 c-0.6,2.7-1.4,5.2-2.6,7.5c-1.1,2.4-2.5,4.5-4.1,6.5s-3.5,3.7-5.5,5.1c-2.1,1.4-4.3,2.6-6.8,3.4c-2.5,0.8-5.1,1.2-8,1.2 c-2.5,0-4.8-0.3-6.9-1c-2.1-0.7-3.9-1.5-5.5-2.6c-1.6-1.1-2.7-2.4-3.6-3.8c-0.9-1.4-1.3-2.9-1.3-4.4c0-1.4,0.2-2.6,0.7-3.6 s1.1-1.7,1.9-2.3c0.8-0.6,1.7-1,2.7-1.3s2-0.4,3.1-0.4c2,0,3.9,0.3,5.7,0.8s3.6,1.3,5.3,2.3c1.7,1,3.2,2.2,4.7,3.6 c1.5,1.4,2.8,3,4,4.7l-1.2,0.8c-1.4-1.9-2.8-3.6-4.3-4.9c-1.5-1.3-3-2.4-4.4-3.3s-2.9-1.4-4.3-1.8c-1.4-0.4-2.7-0.5-3.9-0.5 c-1.2,0-2.2,0.1-3.1,0.4c-0.9,0.3-1.6,0.7-2.1,1.2c-0.6,0.5-1,1.1-1.2,1.8c-0.3,0.7-0.4,1.5-0.4,2.3c0,1.5,0.4,2.9,1.2,4.1 c0.8,1.3,1.8,2.4,3.1,3.3c1.3,0.9,2.8,1.7,4.5,2.2c1.7,0.5,3.5,0.8,5.3,0.8c2.3,0,4.4-0.3,6.3-0.9c1.9-0.6,3.7-1.4,5.3-2.5 c1.6-1.1,3-2.3,4.3-3.7c1.3-1.4,2.4-3,3.4-4.6c1-1.7,1.8-3.4,2.5-5.2s1.3-3.6,1.7-5.3c0.5-1.8,0.8-3.5,1-5.2 c0.2-1.7,0.3-3.2,0.3-4.6c0-1.8-0.2-3.4-0.5-4.8c-0.3-1.4-0.8-2.5-1.3-3.5c-0.5-0.9-1.1-1.6-1.8-2.1c-0.7-0.5-1.4-0.7-2.1-0.7 c-1.1,0-2.2,0.4-3.4,1.2c-1.2,0.8-2.2,2-3.1,3.5c-0.9,1.5-1.7,3.4-2.3,5.7c-0.6,2.2-0.9,4.8-0.9,7.6c0,2.1,0.2,4,0.6,5.7 s0.9,3.1,1.5,4.4c0.6,1.2,1.3,2.3,2,3.1c0.7,0.8,1.4,1.5,2.1,2L285.1,146.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M320.4,140.1c0,0.8-0.1,1.6-0.4,2.5c-0.3,0.8-0.6,1.7-1.1,2.5c-0.4,0.8-0.9,1.7-1.4,2.5s-1,1.6-1.4,2.4 c-0.4,0.8-0.8,1.5-1.1,2.2s-0.4,1.3-0.4,1.9c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.4,0.2,0.6,0.2c0.7,0,1.5-0.4,2.4-1.1 c0.9-0.7,1.8-1.6,2.7-2.7c0.9-1.1,1.8-2.2,2.7-3.5s1.7-2.5,2.5-3.6l1,0.8c-0.2,0.2-0.4,0.7-0.8,1.3c-0.4,0.7-0.9,1.4-1.5,2.3 c-0.6,0.9-1.2,1.8-2,2.7c-0.7,0.9-1.5,1.8-2.3,2.6c-0.8,0.8-1.7,1.4-2.6,1.9c-0.9,0.5-1.8,0.8-2.6,0.8c-0.5,0-1-0.1-1.4-0.3 c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.7,0.2-1.5,0.5-2.4c0.3-0.9,0.7-1.7,1.2-2.6 c0.5-0.9,1-1.8,1.6-2.7s1.1-1.8,1.6-2.6s0.9-1.6,1.2-2.3c0.3-0.7,0.5-1.3,0.5-1.8c0-0.6-0.2-1.1-0.5-1.5c-0.3-0.4-0.8-0.6-1.3-0.6 c-0.6,0-1.3,0.2-2.1,0.8c-0.8,0.5-1.7,1.2-2.7,2.2s-2.1,2.1-3.2,3.6c-1.2,1.4-2.4,3-3.8,4.8c-0.8,1-1.5,2-2.3,3 c-0.3,0.4-0.6,0.8-1,1.3c-0.3,0.4-0.6,0.9-1,1.3c-0.3,0.4-0.6,0.8-0.9,1.2s-0.5,0.7-0.8,1l-2.5-1l3.3-4.6c0.5-0.6,1-1.3,1.4-2.1 c0.5-0.7,1-1.5,1.5-2.3s0.9-1.6,1.4-2.4c0.4-0.8,0.8-1.6,1.2-2.3c0.5-1.1,0.9-2.1,1.1-2.8c0.2-0.7,0.3-1.3,0.3-1.8s-0.1-0.8-0.3-1 c-0.2-0.2-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.2-1.2,0.6c-0.5,0.4-0.9,0.8-1.4,1.4c-0.5,0.6-1,1.2-1.5,2c-0.5,0.7-1,1.4-1.4,2.2 c-0.4,0.8-0.9,1.4-1.3,2s-0.7,1.2-1,1.6l-1-0.8c1-1.5,1.8-2.9,2.6-4.1c0.8-1.3,1.5-2.3,2.3-3.2c0.7-0.9,1.4-1.6,2.1-2.1 s1.4-0.8,2.2-0.8c0.4,0,0.8,0.1,1.2,0.3s0.7,0.4,1,0.8c0.3,0.3,0.5,0.7,0.7,1.2c0.2,0.5,0.3,1,0.3,1.6c0,0.5-0.1,1-0.2,1.5 c0.8-0.8,1.6-1.5,2.3-2s1.4-0.9,2-1.3c0.6-0.3,1.2-0.5,1.7-0.7s1-0.2,1.4-0.2s0.8,0.1,1.2,0.2c0.5,0.1,0.9,0.4,1.3,0.7 c0.4,0.4,0.8,0.9,1.1,1.5C320.2,138.3,320.4,139.1,320.4,140.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.4,139.4c0.5-0.6,1.1-1.2,1.7-1.8c0.6-0.5,1.2-1,1.8-1.4s1.2-0.7,1.7-0.9c0.6-0.2,1.1-0.3,1.7-0.3 c0.4,0,0.8,0.1,1.2,0.2c0.4,0.1,0.8,0.4,1.1,0.7c0.3,0.3,0.6,0.7,0.8,1.1c0.2,0.5,0.3,1,0.3,1.6c0,0.9-0.1,1.8-0.4,2.7 c-0.2,0.9-0.6,1.7-0.9,2.6c-0.4,0.8-0.8,1.6-1.2,2.4s-0.8,1.5-1.2,2.2s-0.7,1.4-0.9,2s-0.4,1.2-0.4,1.7c0,0.4,0.1,0.7,0.3,0.9 s0.4,0.3,0.7,0.3c0.5,0,1.1-0.3,1.7-0.8c0.7-0.6,1.4-1.3,2.1-2.2c0.7-0.9,1.5-1.9,2.2-2.9c0.7-1.1,1.5-2.1,2.1-3.1l1,0.8 c-0.2,0.4-0.6,0.9-0.9,1.6c-0.4,0.7-0.8,1.4-1.3,2.1c-0.5,0.7-1.1,1.5-1.7,2.3s-1.2,1.5-1.9,2.1c-0.7,0.6-1.4,1.1-2.1,1.5 c-0.7,0.4-1.4,0.6-2.2,0.6c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.7-0.3-1-0.6c-0.3-0.3-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.9-0.3-1.5 c0-0.8,0.1-1.6,0.4-2.4c0.3-0.8,0.6-1.6,1.1-2.4c0.4-0.8,0.9-1.5,1.4-2.3s1-1.5,1.4-2.3s0.8-1.5,1.1-2.3s0.4-1.5,0.4-2.3 c0-0.4-0.1-0.7-0.2-0.9c-0.2-0.2-0.4-0.4-0.8-0.4c-0.7,0-1.4,0.3-2.1,0.8c-0.7,0.5-1.5,1.3-2.3,2.2c-0.8,0.9-1.6,2-2.4,3.2 c-0.8,1.2-1.7,2.5-2.5,3.8c-0.8,1.3-1.6,2.7-2.4,4.1c-0.8,1.4-1.6,2.7-2.3,4l-2.4-1.2c1-2.1,1.9-3.9,2.8-5.5s1.6-3.1,2.3-4.4 c0.7-1.3,1.2-2.5,1.6-3.6c0.4-1.1,0.6-2.1,0.6-3.1c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.3-0.4-0.4 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.6,0-1.3,0.3-2,0.9c-0.7,0.6-1.4,1.4-2.1,2.4c-0.7,1-1.5,2.2-2.4,3.6c-0.8,1.4-1.7,2.8-2.7,4.3 s-2,3.1-3.2,4.7c-1.1,1.6-2.4,3.2-3.7,4.7l-2-1.3c0.6-0.9,1.2-1.9,1.9-2.9c0.7-1,1.3-2,2-3.1c0.7-1.1,1.3-2.1,1.9-3.1s1.1-2,1.6-2.9 s0.8-1.8,1.1-2.5c0.3-0.8,0.4-1.4,0.4-2s-0.2-1.1-0.5-1.4c-0.3-0.3-0.7-0.4-1.2-0.4c-0.6,0-1.2,0.2-1.8,0.7c-0.6,0.4-1.2,1-1.8,1.8 c-0.6,0.8-1.3,1.7-2,2.8c-0.7,1.1-1.6,2.3-2.5,3.6l-1-0.8c1-1.6,1.9-3,2.7-4.2s1.6-2.2,2.3-3c0.7-0.8,1.4-1.4,2.1-1.8 c0.7-0.4,1.5-0.6,2.3-0.6c0.2,0,0.6,0,0.9,0.1c0.4,0.1,0.8,0.3,1.1,0.5c0.4,0.2,0.7,0.6,1,1c0.3,0.4,0.5,1,0.5,1.7 c1.1-1.4,2.2-2.4,3.3-3.3c1.2-0.8,2.2-1.2,3.3-1.2c0.7,0,1.4,0.1,1.9,0.4c0.5,0.3,0.9,0.7,1.2,1.1c0.3,0.4,0.5,1,0.7,1.6 c0.1,0.6,0.2,1.2,0.2,1.8c0,0.2,0,0.3,0,0.5C349.4,139.1,349.4,139.3,349.4,139.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.3,136c-0.2,0.5-0.6,1.1-1,1.9c-0.4,0.8-0.9,1.7-1.4,2.6c-0.5,1-1,1.9-1.5,3c-0.5,1-1,2.1-1.4,3 c-0.4,1-0.8,1.9-1,2.8c-0.3,0.9-0.4,1.6-0.4,2.2s0.1,1,0.4,1.2c0.2,0.2,0.5,0.3,0.9,0.3c0.5,0,1.1-0.2,1.7-0.5s1.1-0.7,1.7-1.2 c0.6-0.5,1.1-1.1,1.6-1.7c0.5-0.6,1-1.3,1.5-1.9c0.5-0.7,0.9-1.3,1.3-1.9c0.4-0.6,0.7-1.1,1-1.5l1,0.8c-0.3,0.6-0.7,1.3-1.1,2 s-0.9,1.4-1.4,2.1c-0.5,0.7-1.1,1.4-1.7,2.1c-0.6,0.7-1.2,1.2-1.9,1.8c-0.7,0.5-1.4,0.9-2.1,1.2s-1.5,0.5-2.3,0.5 c-1.1,0-2-0.3-2.5-1s-0.8-1.6-0.8-2.6c0-0.1,0-0.2,0-0.5s0-0.5,0.1-0.6c-0.9,1.2-1.8,2.2-2.7,2.9c-0.9,0.8-1.7,1.4-2.5,1.8 c-0.8,0.5-1.6,0.8-2.3,0.9c-0.7,0.2-1.5,0.3-2.1,0.3c-0.7,0-1.4-0.1-2-0.4c-0.6-0.2-1.2-0.6-1.7-1s-0.9-1-1.1-1.7 c-0.3-0.7-0.4-1.4-0.4-2.3c0-1.1,0.2-2.3,0.7-3.7s1.3-2.9,2.6-4.5c1-1.4,2.1-2.5,3.2-3.5c1.1-0.9,2.2-1.7,3.3-2.3s2.1-1,3.1-1.2 s1.9-0.4,2.6-0.4c1.7,0,3,0.3,3.9,0.9c0.9,0.6,1.4,1.5,1.6,2.6c0.4-0.5,0.8-0.9,1.2-1.4s0.8-1,1.3-1.4L386.3,136z M377.6,146.8 c0.2-0.4,0.5-0.9,0.9-1.5s0.7-1.2,1.1-1.9s0.8-1.3,1.2-1.9c0.4-0.6,0.7-1.1,1-1.5c0-0.2,0-0.4-0.1-0.8c0-0.4-0.2-0.8-0.4-1.1 c-0.2-0.4-0.5-0.7-1-1s-1.1-0.4-1.9-0.4c-0.6,0-1.2,0.1-2,0.3c-0.7,0.2-1.5,0.5-2.3,0.9c-0.8,0.4-1.7,1-2.5,1.7 c-0.9,0.7-1.7,1.6-2.6,2.6c-1.3,1.6-2.3,3.1-3,4.7c-0.7,1.6-1.1,3-1.1,4.3c0,1.1,0.2,1.9,0.7,2.5s1.2,0.9,2.1,0.9c1,0,2-0.2,2.9-0.7 c0.9-0.5,1.8-1.1,2.5-1.8c0.7-0.7,1.5-1.6,2.3-2.5C376.3,148.5,377,147.6,377.6,146.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.1,150.3c-0.8-0.2-1.6-0.4-2.4-0.6c-0.8-0.2-1.6-0.4-2.4-0.6c-1,2-2,3.9-3.1,5.8s-2.2,3.7-3.4,5.6 c-0.9,1.4-2,2.8-3.1,4.1s-2.4,2.6-3.6,3.8c-1.3,1.2-2.6,2.3-4,3.3s-2.7,1.8-4.1,2.6c-1.4,0.7-2.8,1.3-4.1,1.7 c-1.4,0.4-2.7,0.6-4,0.6c-1.2,0-2.3-0.2-3.5-0.6c-1.2-0.4-2.2-1-3.2-1.8s-1.7-1.8-2.3-3c-0.6-1.2-0.9-2.6-0.9-4.3 c0-0.8,0.1-1.7,0.3-2.7c0.2-1,0.5-1.9,1-2.9s1-2,1.8-3.1c0.7-1,1.6-2.1,2.6-3.2c1.4-1.5,2.9-2.7,4.6-3.8s3.5-1.9,5.5-2.6 c1.9-0.7,3.9-1.2,6-1.5s4.2-0.5,6.4-0.5c1.4,0,2.8,0.1,4.2,0.2s2.8,0.3,4.2,0.6c1-2.1,1.9-4.1,2.7-6.2c0.8-2.1,1.5-4.1,2.1-6.1 c0.9-3.1,1.6-5.7,2-8c0.4-2.3,0.6-4.2,0.6-5.8c0-1.4-0.1-2.6-0.3-3.6c-0.2-1-0.5-1.9-0.9-2.6c-0.4-0.7-0.8-1.3-1.2-1.7 c-0.5-0.4-0.9-0.8-1.4-1s-1-0.4-1.4-0.5c-0.5-0.1-0.9-0.1-1.2-0.1c-1.5,0-2.9,0.4-4.1,1.1s-2.2,1.7-3,3c-0.8,1.3-1.4,2.9-1.9,4.7 c-0.4,1.8-0.7,3.9-0.7,6.1c0,1.8,0.2,3.4,0.5,4.9c0.3,1.5,0.7,2.9,1.1,4.1c0.4,1.2,0.9,2.3,1.5,3.3s1,1.7,1.5,2.4s0.8,1.1,1.1,1.5 c0.3,0.3,0.5,0.5,0.5,0.5l-0.9,0.9c-1.2-1-2.3-2.2-3.4-3.5s-2-2.6-2.7-4.1c-0.8-1.5-1.4-3-1.8-4.6c-0.5-1.6-0.7-3.3-0.7-5.1 c0-2,0.3-4,0.9-6s1.4-3.8,2.5-5.3c1.1-1.6,2.5-2.8,4.1-3.8s3.5-1.4,5.6-1.4c0.5,0,1,0,1.6,0.1s1.3,0.3,1.9,0.6 c0.7,0.3,1.3,0.7,2,1.2c0.7,0.5,1.2,1.2,1.7,2.1c0.5,0.9,0.9,2,1.2,3.2c0.3,1.3,0.5,2.8,0.5,4.6c0,0.8,0,1.7-0.1,2.6 c-0.1,0.9-0.2,1.9-0.3,3c-0.5,3.5-1.3,7-2.4,10.4s-2.3,6.7-3.9,10c0.8,0.2,1.6,0.3,2.3,0.5c0.8,0.2,1.5,0.4,2.2,0.6L473.1,150.3z  M438.9,175c1.4,0.1,2.9-0.2,4.4-0.8s3.1-1.5,4.6-2.7s3.1-2.6,4.6-4.3s3-3.5,4.5-5.5s2.9-4.1,4.2-6.3c1.3-2.2,2.6-4.5,3.8-6.9 c-1-0.1-1.9-0.2-2.9-0.3s-1.9-0.1-2.9-0.1c-2.9,0-5.7,0.3-8.2,1s-4.8,1.5-6.8,2.6s-3.9,2.4-5.4,3.8c-1.6,1.4-2.9,2.9-3.9,4.4 c-1.1,1.5-1.9,3-2.4,4.5s-0.8,2.8-0.8,4.1c0,1,0.2,1.8,0.5,2.6c0.3,0.8,0.8,1.5,1.4,2.1s1.4,1,2.3,1.3 C436.8,174.8,437.7,175,438.9,175z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M492.5,147.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.5,0,1-0.1,1.4-0.2c0.4-0.1,0.8-0.3,1.2-0.5 s0.7-0.5,1.1-0.9c0.3-0.4,0.7-0.8,1-1.3l1,0.8c-0.9,1.3-1.8,2.2-2.8,2.7s-2,0.8-3.1,0.8c-0.4,0-0.7,0-1-0.1 c-0.8,1.4-1.7,2.5-2.6,3.5c-0.9,1-1.9,1.7-2.8,2.3c-0.9,0.6-1.9,1-2.9,1.3c-0.9,0.3-1.8,0.4-2.6,0.4c-0.8,0-1.6-0.1-2.3-0.4 c-0.7-0.3-1.3-0.7-1.8-1.3s-0.9-1.2-1.2-2c-0.3-0.8-0.4-1.6-0.4-2.5s0.2-1.9,0.5-2.9c0.3-1,0.7-2,1.2-2.9s1.1-1.9,1.8-2.8 c0.7-0.9,1.5-1.7,2.3-2.5c0.8-0.8,1.7-1.5,2.5-2.1c0.9-0.6,1.7-1.1,2.6-1.5l0.9,1.2c-1,0.7-2,1.6-3,2.7s-2,2.3-2.8,3.6 c-0.8,1.3-1.5,2.7-2.1,4.1c-0.5,1.4-0.8,2.8-0.8,4.1c0,1.2,0.3,2.1,0.8,2.8s1.3,1,2.4,1c0.8,0,1.7-0.2,2.5-0.5 c0.8-0.3,1.6-0.8,2.4-1.4c0.8-0.6,1.5-1.3,2.2-2.1c0.7-0.8,1.4-1.7,2-2.6c-0.5-0.3-1-0.8-1.4-1.3s-0.8-1.2-1-1.8 c-0.3-0.7-0.5-1.4-0.6-2.2s-0.2-1.6-0.2-2.4s0.1-1.6,0.3-2.4c0.2-0.7,0.5-1.4,0.9-1.9c0.4-0.6,0.8-1,1.3-1.3s1-0.5,1.6-0.5 c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.8,0.7,1,1.1c0.3,0.5,0.5,1.1,0.7,1.7c0.2,0.7,0.2,1.4,0.2,2.1c0,0.6,0,1.2-0.1,1.9s-0.2,1.4-0.4,2.1 c-0.2,0.7-0.4,1.4-0.7,2C493.1,146,492.8,146.6,492.5,147.1z M488.6,140.1c0,0.5,0,1.1,0.1,1.8c0.1,0.6,0.2,1.3,0.5,1.9 c0.2,0.6,0.5,1.2,0.8,1.7c0.3,0.5,0.7,0.9,1.2,1.2c0.3-0.7,0.6-1.3,0.9-2c0.2-0.7,0.4-1.4,0.6-2c0.2-0.6,0.3-1.2,0.3-1.8 c0.1-0.6,0.1-1,0.1-1.5c0-0.6,0-1.1-0.1-1.6s-0.2-0.9-0.4-1.2c-0.2-0.3-0.4-0.6-0.6-0.8c-0.2-0.2-0.5-0.3-0.8-0.3 c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.6,0.6-0.8,1c-0.2,0.4-0.4,0.9-0.5,1.5C488.7,138.9,488.6,139.5,488.6,140.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M521.3,140.1c0,0.8-0.1,1.6-0.4,2.5c-0.3,0.8-0.6,1.7-1.1,2.5c-0.4,0.8-0.9,1.7-1.4,2.5s-1,1.6-1.4,2.4 c-0.4,0.8-0.8,1.5-1.1,2.2s-0.4,1.3-0.4,1.9c0,0.4,0.1,0.7,0.3,0.9c0.2,0.2,0.4,0.2,0.6,0.2c0.7,0,1.5-0.4,2.4-1.1 c0.9-0.7,1.8-1.6,2.7-2.7c0.9-1.1,1.8-2.2,2.7-3.5s1.7-2.5,2.5-3.6l1,0.8c-0.2,0.2-0.4,0.7-0.8,1.3c-0.4,0.7-0.9,1.4-1.5,2.3 c-0.6,0.9-1.2,1.8-2,2.7c-0.7,0.9-1.5,1.8-2.3,2.6s-1.7,1.4-2.6,1.9c-0.9,0.5-1.8,0.8-2.6,0.8c-0.5,0-1-0.1-1.4-0.3 c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.7,0.2-1.5,0.5-2.4s0.7-1.7,1.2-2.6 c0.5-0.9,1-1.8,1.6-2.7c0.6-0.9,1.1-1.8,1.6-2.6s0.9-1.6,1.2-2.3s0.5-1.3,0.5-1.8c0-0.6-0.2-1.1-0.5-1.5s-0.8-0.6-1.3-0.6 c-0.6,0-1.3,0.2-2.1,0.8c-0.8,0.5-1.7,1.2-2.7,2.2c-1,1-2.1,2.1-3.2,3.6c-1.2,1.4-2.4,3-3.8,4.8c-0.8,1-1.5,2-2.3,3 c-0.3,0.4-0.6,0.8-1,1.3c-0.3,0.4-0.6,0.9-1,1.3c-0.3,0.4-0.6,0.8-0.9,1.2s-0.5,0.7-0.8,1l-2.5-1l3.3-4.6c0.5-0.6,1-1.3,1.4-2.1 c0.5-0.7,1-1.5,1.5-2.3s0.9-1.6,1.4-2.4c0.4-0.8,0.8-1.6,1.2-2.3c0.5-1.1,0.9-2.1,1.1-2.8c0.2-0.7,0.3-1.3,0.3-1.8s-0.1-0.8-0.3-1 c-0.2-0.2-0.5-0.2-0.8-0.2c-0.4,0-0.8,0.2-1.2,0.6c-0.5,0.4-0.9,0.8-1.4,1.4c-0.5,0.6-1,1.2-1.5,2c-0.5,0.7-1,1.4-1.4,2.2 s-0.9,1.4-1.3,2c-0.4,0.6-0.7,1.2-1,1.6l-1-0.8c1-1.5,1.8-2.9,2.6-4.1c0.8-1.3,1.5-2.3,2.3-3.2c0.8-0.9,1.4-1.6,2.1-2.1 c0.7-0.5,1.4-0.8,2.2-0.8c0.4,0,0.8,0.1,1.2,0.3s0.7,0.4,1,0.8c0.3,0.3,0.5,0.7,0.7,1.2s0.3,1,0.3,1.6c0,0.5-0.1,1-0.2,1.5 c0.8-0.8,1.6-1.5,2.3-2c0.7-0.5,1.4-0.9,2-1.3c0.6-0.3,1.2-0.5,1.7-0.7s1-0.2,1.4-0.2c0.4,0,0.8,0.1,1.2,0.2 c0.5,0.1,0.9,0.4,1.3,0.7c0.4,0.4,0.8,0.9,1.1,1.5C521.2,138.3,521.3,139.1,521.3,140.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M539.3,148.5c-0.7,0.8-1.5,1.6-2.2,2.3c-0.8,0.7-1.5,1.3-2.2,1.8s-1.5,0.9-2.2,1.2s-1.4,0.4-2.1,0.4 s-1.4-0.1-2-0.4c-0.6-0.3-1.1-0.7-1.5-1.2c-0.4-0.5-0.8-1.1-1-1.8s-0.3-1.5-0.3-2.3c0-1.1,0.2-2.3,0.7-3.5s1.1-2.4,1.8-3.6 c0.7-1.2,1.6-2.3,2.5-3.3c0.9-1,1.8-1.9,2.7-2.7l1.2,0.8c-0.2,0.3-0.5,0.8-0.9,1.3c-0.4,0.5-0.8,1.2-1.3,2c-0.5,0.7-0.9,1.6-1.4,2.4 s-0.9,1.8-1.3,2.7c-0.4,0.9-0.7,1.8-0.9,2.7s-0.4,1.8-0.4,2.5c0,0.4,0,0.7,0.1,1.1c0.1,0.3,0.2,0.7,0.3,0.9s0.4,0.5,0.6,0.6 c0.3,0.2,0.6,0.2,1,0.2c0.7,0,1.4-0.2,2.2-0.6c0.8-0.4,1.6-1,2.4-1.7s1.7-1.5,2.6-2.5c0.9-1,1.7-2,2.6-3c0.9-1,1.7-2.2,2.5-3.3 s1.5-2.3,2.2-3.4c0.6-1,1.2-2,1.8-3c0.6-1,1.2-2,1.8-3l1.3,0.7c0,0-0.2,0.4-0.5,1.1c-0.3,0.7-0.8,1.6-1.3,2.7 c-0.5,1.1-1.2,2.5-1.9,4c-0.7,1.5-1.5,3.1-2.3,4.8s-1.6,3.4-2.5,5.2c-0.9,1.8-1.7,3.5-2.4,5.2c2.7-1.5,5.1-3.2,7.2-5.2 c2.2-2,4-4.1,5.6-6.3l1,0.8c-1.6,2.5-3.7,4.8-6.1,7c-2.4,2.1-5.4,4.2-8.8,6.1c-1.6,3.4-3.1,6.4-4.6,9.2s-3,5.2-4.5,7.1 s-3,3.5-4.5,4.6s-3,1.6-4.6,1.6c-1,0-1.9-0.3-2.5-1c-0.6-0.7-1-1.7-1-2.9c0-1.1,0.2-2.1,0.7-3.3c0.5-1.1,1.1-2.2,2-3.4 c0.8-1.1,1.8-2.2,3-3.3c1.1-1.1,2.4-2.2,3.7-3.2c1.3-1,2.8-2,4.2-2.9s3-1.8,4.5-2.5c0.4-0.8,0.8-1.7,1.3-2.6 c0.5-0.9,0.9-1.8,1.3-2.7c0.4-0.9,0.9-1.7,1.3-2.4C538.6,149.7,539,149,539.3,148.5z M533.1,160.9c-2.2,1.3-4.2,2.8-6,4.3 c-1.9,1.5-3.5,3-4.8,4.5c-1.4,1.5-2.4,2.9-3.2,4.2c-0.8,1.3-1.2,2.4-1.2,3.3c0,0.6,0.2,1.1,0.5,1.4c0.3,0.4,0.8,0.5,1.3,0.5 c0.7,0,1.5-0.2,2.3-0.8c0.8-0.5,1.6-1.2,2.4-2.1s1.6-1.9,2.3-3.1c0.8-1.2,1.5-2.4,2.3-3.8c0.7-1.4,1.5-2.8,2.2-4.2 C531.8,163.8,532.4,162.3,533.1,160.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351,197.1c0-5.2,2.8-8.3,6.6-8.3s6.6,3.1,6.6,8.3c0,5.2-2.8,8.3-6.6,8.3C353.8,205.4,351,202.4,351,197.1z  M362.4,197.1c0-4.4-1.9-6.7-4.8-6.7s-4.8,2.3-4.8,6.7s1.9,6.7,4.8,6.7C360.5,204,362.4,201.5,362.4,197.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371,189v16.3h-1.7v-14.7h-3.8v-1.5h5.5V189z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.9,204.1c0-0.7,0.6-1.3,1.2-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C375.5,205.4,374.9,204.8,374.9,204.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M379.5,197.1c0-5.2,2.8-8.3,6.6-8.3s6.6,3.1,6.6,8.3c0,5.2-2.8,8.3-6.6,8.3S379.5,202.4,379.5,197.1z  M390.8,197.1c0-4.4-1.9-6.7-4.8-6.7s-4.8,2.3-4.8,6.7s1.9,6.7,4.8,6.7C388.9,204,390.8,201.5,390.8,197.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M406.3,189v1.2l-6.8,15.1h-1.7l6.7-14.9H396v3.1h-1.6V189C394.4,189,406.3,189,406.3,189z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.2,204.1c0-0.7,0.6-1.3,1.2-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3 C407.8,205.4,407.2,204.8,407.2,204.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.5,203.8v1.5H412v-1.2l6.8-6.7c1.9-1.7,2.2-2.9,2.2-4.1c0-1.9-1.3-3.1-3.8-3.1c-1.9,0-3.3,0.6-4.5,1.7 l-1.2-1c1.3-1.5,3.3-2.3,5.8-2.3c3.3,0,5.4,1.7,5.4,4.4c0,1.6-0.4,2.9-2.6,5.1l-5.5,5.4h8.9V203.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M425.6,197.1c0-5.2,2.8-8.3,6.6-8.3s6.6,3.1,6.6,8.3c0,5.2-2.8,8.3-6.6,8.3S425.6,202.4,425.6,197.1z  M436.9,197.1c0-4.4-1.9-6.7-4.8-6.7s-4.8,2.3-4.8,6.7s1.9,6.7,4.8,6.7C434.9,204,436.9,201.5,436.9,197.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M452.1,203.8v1.5h-11.5v-1.2l6.8-6.7c1.9-1.7,2.2-2.9,2.2-4.1c0-1.9-1.3-3.1-3.8-3.1c-1.9,0-3.3,0.6-4.5,1.7 l-1.2-1c1.3-1.5,3.3-2.3,5.8-2.3c3.3,0,5.4,1.7,5.4,4.4c0,1.6-0.4,2.9-2.6,5.1l-5.5,5.4h8.9V203.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465,200.6c0,2.8-2,4.8-6,4.8c-2.3,0-4.7-0.9-5.8-2l0.9-1.3c1,1.2,2.9,1.9,5.1,1.9c2.8,0,4.2-1.3,4.2-3.3 c0-1.9-1.3-3.2-4.4-3.2h-1.5v-1.2l4.5-5.7h-8.3v-1.5h10.5v1.2l-4.7,5.8C463.3,196.2,465,198,465,200.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 1.1,
    width: 779,
    height: 315
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067925538092502390390000010216120789286777236_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000067925538092502390390000010216120789286777236_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000161628010943569239630000008683744692844145302_",
    x: 0.3,
    y: -781.6,
    width: 779.7,
    height: 1093.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139252289439843173950000000965903684981187205_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161628010943569239630000008683744692844145302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_321_00000052070919427442544780000005983238577625133480_",
    gradientUnits: "userSpaceOnUse",
    x1: -945.1205,
    y1: -1414.5927,
    x2: -944.1255,
    y2: -1414.5927,
    gradientTransform: "matrix(1014.39 0 0 507.2524 958646.4375 717939.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8EAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F5DFC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDC797"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_321_00000052070919427442544780000005983238577625133480_)"
    },
    d: " M660.4,186c-27.8,40.8-33.1,98-46.8,149.1s-40.5,100.1-92.8,106.6c-52.4,6.5-113.8-31-171.7-54.8 c-119.7-49.2-241.9-39.3-318.6,25.8C2.1,437-20.9,476.8-1,523.3c14.2,33.2,47.2,59.6,78.9,72.3s62.9,14.1,93.3,15.4 c197.9,8.3,395.9,16.6,593.8,24.9c67.5,2.8,138.6,4.7,185.5-31.6c42.5-32.9,58.8-93.9,54.6-158.8c-2.8-44.8-16.7-89.9-28.6-135.9 c-7.2-27.8-11.4-57.9-25.6-85.5c-36.2-70.5-135-97.7-189.1-93.6C719.3,133.6,682.7,153.3,660.4,186L660.4,186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_322_00000142868658681585716080000004392699642856565680_",
    gradientUnits: "userSpaceOnUse",
    x1: -940.6544,
    y1: -1413.152,
    x2: -941.8534,
    y2: -1414.547,
    gradientTransform: "matrix(190.3739 0 0 187.095 179122.4375 264657.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_322_00000142868658681585716080000004392699642856565680_)"
    },
    d: " M177.1,212.3c-3.5,11.5-11.9,21.2-23.2,29.7c-11.2,8.4-25.1,15.7-39.6,22.5c-14,6.6-28.5,12.8-41.7,19 C56.8,291,42.5,305.2,30,321.9c-17.9,23.9-31.8,53-39.6,75.6c-0.4,0.9-1.4,1.4-2.4,1c-1-0.3-1.5-1.3-1.2-2.3 c8-22.8,22-52.3,40.4-76.2c12.9-16.9,28-31,44.3-38.4c11.4-5.2,23.9-10.3,36.1-15.7c12.2-5.4,24.3-11.2,34.8-17.7 c16.3-10,29-21.6,33.5-36.2c0.1-0.3,0.5-0.5,0.8-0.4C177,211.7,177.2,212,177.1,212.3L177.1,212.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_323_00000131330007831404749450000007995852634794378935_",
    gradientUnits: "userSpaceOnUse",
    x1: -891.2784,
    y1: -1387.6332,
    x2: -904.6464,
    y2: -1403.5571,
    gradientTransform: "matrix(17.0822 0 0 16.3889 15373.2695 22911.4824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_323_00000131330007831404749450000007995852634794378935_)"
    },
    d: " M176.5,212.1c-0.7-1.4-5-8.4-5-15.2c0-4.5,18.7,5.3,17,11.4C187.9,210.2,181.5,211.3,176.5,212.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_324_00000030450944131926788390000007746362258888431539_",
    gradientUnits: "userSpaceOnUse",
    x1: -896.2571,
    y1: -1390.1433,
    x2: -908.4081,
    y2: -1404.6633,
    gradientTransform: "matrix(18.7934 0 0 17.9731 16991.1875 25154.0703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_324_00000030450944131926788390000007746362258888431539_)"
    },
    d: " M175.7,212.5l-0.2-0.4c-1.2-2.2-4.9-8.7-4.9-15.2c0-0.8,0.5-1.5,1.2-1.7c2.6-1,8.9,2.1,13,5.4c3.5,2.9,5.1,5.7,4.5,8 c-0.6,2.2-5.8,3.2-12.6,4.4c-0.2,0-0.3,0-0.5,0C176,212.8,175.8,212.7,175.7,212.5z M172.5,196.6c-0.1,0-0.2,0.1-0.2,0.3 c0,4,1.5,8.8,4.6,14.3c3.7-0.6,10.3-1.8,10.7-3.2c0.4-1.6-1-3.9-3.9-6.3c-2.5-2-5.2-3.6-8.2-4.7 C174.6,196.6,173.6,196.5,172.5,196.6L172.5,196.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_325_00000150094587780394844330000006438591756721625219_",
    gradientUnits: "userSpaceOnUse",
    x1: -935.2839,
    y1: -1406.5884,
    x2: -938.5299,
    y2: -1417.3584,
    gradientTransform: "matrix(70.3485 0 0 24.2327 65752.7344 34059.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_325_00000150094587780394844330000006438591756721625219_)"
    },
    d: " M161.1,242.9c-0.1-0.5,0.1-0.9,0.5-1.2c0.1-0.1,0.3-0.2,0.5-0.3c11.7-7.6,24-4.8,32.3-1.2c11.6,5.1,23.8,8.9,36.3,11.1 c0.3,0,0.6,0.3,0.7,0.6c0.1,0.3,0,0.7-0.3,0.8c-0.2,0.1-21.7,13.2-44.5,5.6l-1-0.3C170.4,252.8,161.4,245.3,161.1,242.9 L161.1,242.9z M193.7,241.7c-7.9-3.5-19.5-6.1-30.6,1.1c-0.1,0.1-0.2,0.1-0.3,0.2c0.8,1.7,8.7,8.8,24.2,14 c18.1,6.1,35.5-1.5,41.1-4.4C216.3,250.2,204.7,246.5,193.7,241.7L193.7,241.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_326_00000119094284952971768000000016253311240132991134_",
    gradientUnits: "userSpaceOnUse",
    x1: -899.5956,
    y1: -1402.403,
    x2: -908.4356,
    y2: -1406.9819,
    gradientTransform: "matrix(25.833 0 0 56.9861 23587.207 80407.2031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_326_00000119094284952971768000000016253311240132991134_)"
    },
    d: " M113.9,260.1c-0.1-0.1-11.6-10.5-4.1-29.3c7.4-18.5,19.2-27,19.7-27.3c0.3-0.2,0.6-0.2,0.9-0.1c0.3,0.1,0.5,0.4,0.5,0.7 c0,0.1,1.3,14.6,2.2,29.7c0.7,12.6-4.7,20.5-18.2,26.4c-0.2,0.1-0.4,0.1-0.7,0C114.1,260.2,114,260.2,113.9,260.1L113.9,260.1z  M111.4,231.5c-6.4,15.9,1.2,25.1,3.2,27.1c12.5-5.6,17.4-12.9,16.7-24.7c-0.7-12.1-1.6-23.9-2-28 C121.4,212.8,115.2,221.6,111.4,231.5L111.4,231.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_327_00000181058750637583267560000003362500026555254707_",
    gradientUnits: "userSpaceOnUse",
    x1: -936.3448,
    y1: -1410.7047,
    x2: -939.6088,
    y2: -1420.3058,
    gradientTransform: "matrix(69.9636 0 0 27.1804 65280.1445 38288.5703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_327_00000181058750637583267560000003362500026555254707_)"
    },
    d: " M52.8,298.9c-0.5-1.1,0-1.6,0.3-1.7l0,0c1.7-1,26.4-9.9,42.5-3.5c15.7,6.2,26.4,23,26.9,23.7c0.2,0.3,0.2,0.7-0.1,1 c-0.3,0.2-0.7,0.3-1.1,0.1c-0.1-0.1-8.4-5-30.2-2.1c-5.8,0.7-11.7,0.1-17.2-1.9C61.8,310.3,53.9,301.4,52.8,298.9L52.8,298.9z  M94.9,295.1c-14.5-5.7-37.2,1.8-40.6,3.2c0.5,1.1,3.2,4.6,7.8,8.1c5.1,3.8,15.5,10,28.5,8.3c15.8-2.1,24.7-0.2,28.7,1.2 C115.9,311.1,106.7,299.8,94.9,295.1L94.9,295.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_328_00000140711741170899848780000013506491492609335983_",
    gradientUnits: "userSpaceOnUse",
    x1: -893.8365,
    y1: -1400.7903,
    x2: -902.8995,
    y2: -1405.1404,
    gradientTransform: "matrix(25.2231 0 0 59.991 22932.1211 84701.3047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_328_00000140711741170899848780000013506491492609335983_)"
    },
    d: " M29,287.7c0.3-7.4,4.2-13,8-18.5c2.1-2.9,4-6,5.6-9.2c1.7-3.4,2.9-7.1,3.5-10.9c0.2-1.5,0.2-3,0.1-4.6v-0.1 c-0.2-1-0.3-1.8,0.4-2.1c0.2-0.1,0.5-0.1,0.7,0c0.3,0.1,0.5,0.2,1.1,2.2c0.4,1.2,0.8,2.4,1.3,3.6c2.2,5.7,3.7,11.6,4.4,17.6 c0.6,5.5,0.1,11-1.4,16.3c-1.6,5.3-3.3,10.8-14.8,20.1c-0.2,0.2-0.6,0.2-0.8,0.1C31.5,300.4,28.8,292.6,29,287.7L29,287.7z  M47.8,249.4c-0.6,3.9-1.8,7.8-3.6,11.3c-1.6,3.3-3.6,6.4-5.7,9.4c-3.8,5.6-7.5,10.8-7.7,17.8c-0.2,4.1,2,10.8,6.3,12.7 c10.8-8.8,12.4-14,13.9-19.1s1.9-10.4,1.3-15.7c-0.7-5.9-2.1-11.7-4.3-17.2c0-0.1-0.1-0.2-0.1-0.3C47.9,248.6,47.8,249,47.8,249.4 L47.8,249.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_329_00000016056206717038448710000011701720719645447316_",
    gradientUnits: "userSpaceOnUse",
    x1: -934.2463,
    y1: -1401.743,
    x2: -937.9774,
    y2: -1421.3571,
    gradientTransform: "matrix(61.2062 0 0 13.3149 57095.9531 18603.1211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_329_00000016056206717038448710000011701720719645447316_)"
    },
    d: " M153.5,241.9c0.1,0,0.1,0,0.2,0c19.3,2,27.1,4.5,34,6.7c6.3,2,12.2,3.9,25.5,5c0.4,0.1,0.8-0.2,0.9-0.7c0,0,0,0,0-0.1 c0-0.5-0.4-0.8-0.8-0.9c-13.1-1.1-18.6-2.9-25.1-4.9c-7-2.2-14.9-4.8-34.4-6.8c-0.4-0.1-0.8,0.2-0.9,0.6c0,0,0,0,0,0.1 C152.9,241.4,153.1,241.7,153.5,241.9L153.5,241.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_330_00000053511115387085114010000008190289936341820319_",
    gradientUnits: "userSpaceOnUse",
    x1: -843.9382,
    y1: -1397.594,
    x2: -862.1162,
    y2: -1403.084,
    gradientTransform: "matrix(12.5508 0 0 47.5493 11028.4365 67057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_330_00000053511115387085114010000008190289936341820319_)"
    },
    d: " M113.9,263.7L113.9,263.7c0.4,0.2,0.9,0,1.1-0.5c2.4-6.8,3.9-13.9,4.5-21c0.7-6.3,1.3-12.3,6.3-24.9c0.1-0.4-0.1-0.9-0.5-1l0,0 c-0.4-0.2-0.9,0-1.1,0.4c-5.1,12.7-5.7,18.8-6.4,25.3c-0.6,7.1-2.1,14-4.5,20.7C113.3,263.1,113.5,263.5,113.9,263.7L113.9,263.7z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_331_00000165946997170560070060000015444516596549651085_",
    gradientUnits: "userSpaceOnUse",
    x1: -822.9066,
    y1: -1393.8734,
    x2: -842.7836,
    y2: -1399.5005,
    gradientTransform: "matrix(11.4824 0 0 46.3782 9941.0908 65446.1914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_331_00000165946997170560070060000015444516596549651085_)"
    },
    d: " M37.7,310.1c0.1,0,0.3,0.1,0.4,0c0.4,0,0.7-0.4,0.7-0.8c0,0,0,0,0-0.1c-1.3-5.9,1.3-27.7,9.4-44.3c0.2-0.4,0-0.9-0.4-1.1l0,0 c-0.4-0.2-0.9-0.1-1.1,0.3c-8.2,16.9-10.9,39.2-9.5,45.3C37.2,309.8,37.4,310,37.7,310.1L37.7,310.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_332_00000128484986815384528620000002239224384876890290_",
    gradientUnits: "userSpaceOnUse",
    x1: -935.2863,
    y1: -1410.4758,
    x2: -939.2753,
    y2: -1430.9248,
    gradientTransform: "matrix(57.2353 0 0 12.7698 53235.5703 17887.6289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_332_00000128484986815384528620000002239224384876890290_)"
    },
    d: " M49.6,298.4c0.1,0,0.2,0.1,0.3,0.1c26.2,0.1,42,5.4,55.2,11.1c0.4,0.2,0.9,0,1.1-0.4s0-0.9-0.5-1.1l0,0 c-13.4-5.8-29.4-11.1-55.9-11.2c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0,0,0.1C49,298,49.2,298.3,49.6,298.4L49.6,298.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_333_00000094577201141114789900000016673019711121583007_",
    gradientUnits: "userSpaceOnUse",
    x1: -832.9259,
    y1: -1367.2737,
    x2: -859.3779,
    y2: -1392.2207,
    gradientTransform: "matrix(8.6319 0 0 10.4604 7383.853 14561.7979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_333_00000094577201141114789900000016673019711121583007_)"
    },
    d: " M184.7,241.3c-0.9,0.3-1.8,0.6-2.7,0.9c-0.9,0.3-1.7,0.7-2.5,1.2c-0.4,0.2-0.7,0.4-1.1,0.7c-0.3,0.2-0.4,0.4-0.5,0.7s-0.1,0.7,0,1 c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.4,0.6,0.5,0.9c0.3,0.4,0.5,0.7,0.9,1.1c0.5,0.5,1,1,1.5,1.6v0.1l0,0 h-0.1c-0.6-0.4-1.2-0.8-1.8-1.2c-0.4-0.3-0.8-0.6-1.1-0.9c-0.3-0.3-0.5-0.5-0.8-0.8c-0.2-0.3-0.5-0.6-0.7-0.9 c-0.4-0.6-0.7-1.2-0.9-1.8c-0.1-0.5-0.1-1,0-1.5s0.4-0.9,0.8-1.2c0.5-0.4,1.1-0.7,1.7-0.9c1-0.3,1.9-0.6,2.9-0.8s2-0.3,3-0.3 C184.7,241.1,184.7,241.1,184.7,241.3C184.7,241.2,184.7,241.3,184.7,241.3L184.7,241.3L184.7,241.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_334_00000064328915017411116130000004068157945410870147_",
    gradientUnits: "userSpaceOnUse",
    x1: -806.9697,
    y1: -1361.0258,
    x2: -838.7727,
    y2: -1387.7977,
    gradientTransform: "matrix(7.175 0 0 9.7461 6017.7266 13554.5645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_334_00000064328915017411116130000004068157945410870147_)"
    },
    d: " M195.3,245.6c-0.4,0.2-0.7,0.4-1.1,0.6c-0.5,0.3-1,0.7-1.5,1c-0.6,0.4-1.2,0.8-1.7,1.3c-0.3,0.3-0.6,0.6-0.8,0.9 c-0.1,0.2-0.3,0.4-0.3,0.7c-0.1,0.3-0.2,0.7-0.1,1.1c0,0.2,0.1,0.3,0.1,0.5s0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.3,0.5,0.5,0.7,0.8c0.4,0.4,0.9,0.7,1.3,1v0.1h-0.1c-0.6-0.2-1.1-0.4-1.6-0.7 c-0.4-0.2-0.7-0.4-1-0.6c-0.2-0.2-0.4-0.3-0.6-0.5c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1-0.2-0.2-0.4-0.3-0.7 c-0.2-0.6-0.2-1.2-0.1-1.8c0.1-0.4,0.3-0.8,0.5-1.1c0.3-0.4,0.8-0.8,1.2-1.1c0.7-0.4,1.4-0.8,2.1-1c0.6-0.2,1.2-0.5,1.8-0.6 c0.4-0.1,0.8-0.2,1.3-0.3C195.2,245.5,195.3,245.5,195.3,245.6L195.3,245.6L195.3,245.6L195.3,245.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_335_00000023276711715381738030000010087094278036372414_",
    gradientUnits: "userSpaceOnUse",
    x1: -817.7864,
    y1: -1356.0143,
    x2: -849.7696,
    y2: -1391.5203,
    gradientTransform: "matrix(7.1401 0 0 7.3501 5995.8257 10164.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_335_00000023276711715381738030000010087094278036372414_)"
    },
    d: " M206.4,248.9c-0.8,0.4-1.6,0.8-2.4,1.3c-0.3,0.2-0.6,0.4-0.9,0.6c-0.5,0.3-0.9,0.6-1.3,0.9c-0.2,0.1-0.4,0.3-0.5,0.5 c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.5,0.2,0.9,0.6,1.2c0.2,0.2,0.3,0.3,0.5,0.5s0.4,0.3,0.6,0.4c0.3,0.2,0.5,0.4,0.8,0.5 c0.4,0.3,0.8,0.5,1.3,0.7c0,0,0.1,0,0,0.1c0,0-0.1,0.1-0.1,0c-0.4-0.1-0.8-0.2-1.2-0.3s-0.8-0.2-1.2-0.4c-0.3-0.1-0.5-0.2-0.8-0.3 s-0.5-0.3-0.7-0.4c-0.8-0.5-1.3-1.3-1.4-2.2c0-0.5,0.2-0.9,0.5-1.3c0.3-0.3,0.6-0.6,1-0.8c0.7-0.4,1.4-0.7,2.2-0.9 c1.1-0.3,2.3-0.6,3.4-0.7C206.4,248.8,206.4,248.8,206.4,248.9C206.5,248.9,206.5,248.9,206.4,248.9L206.4,248.9L206.4,248.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_336_00000141413363812559490570000010778699028634158268_",
    gradientUnits: "userSpaceOnUse",
    x1: -865.429,
    y1: -1370.002,
    x2: -886.0168,
    y2: -1398.7839,
    gradientTransform: "matrix(11.0928 0 0 9.0708 9653.3701 12574.7939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_336_00000141413363812559490570000010778699028634158268_)"
    },
    d: " M117.9,222.1c-0.1,0.3,0,0.5,0,0.8c0.1,0.4,0.3,0.9,0.4,1.2c0.2,0.6,0.4,1.1,0.6,1.6s0.5,1,0.8,1.5s0.7,0.9,1.1,1.3 c0.4,0.4,0.8,0.6,1.2,0.8c1,0.5,2.2,0.5,3.3,0.1c1.1-0.4,2.2-1.1,3.1-1.9h0.1v0.1l0,0c-0.6,0.9-1.3,1.7-2.2,2.4 c-0.4,0.3-0.8,0.5-1.3,0.7c-1.2,0.4-2.4,0.5-3.6,0.1c-0.6-0.2-1.1-0.5-1.6-0.9c-0.4-0.4-0.8-0.8-1.1-1.3c-0.3-0.5-0.6-1.1-0.8-1.7 c-0.3-0.9-0.4-1.7-0.5-2.6c0-0.4-0.1-0.9-0.1-1.3c0-0.3,0.1-0.6,0.2-0.9C117.8,222,117.8,222,117.9,222.1 C117.9,222,117.9,222,117.9,222.1L117.9,222.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_337_00000143578618699576412600000009945083279294817664_",
    gradientUnits: "userSpaceOnUse",
    x1: -884.9674,
    y1: -1377.8159,
    x2: -901.7765,
    y2: -1407.0769,
    gradientTransform: "matrix(13.5826 0 0 8.9207 12006.043 12371.9121)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_337_00000143578618699576412600000009945083279294817664_)"
    },
    d: " M115.1,231.8c0.1,0.4,0.2,0.8,0.3,1.2c0.2,0.6,0.5,1.2,0.8,1.8c0.2,0.4,0.5,0.9,0.8,1.3c0.3,0.4,0.6,0.8,0.9,1.2 c0.4,0.6,1,1,1.7,1.3c0.4,0.2,0.9,0.4,1.4,0.5c0.6,0.1,1.2,0.2,1.9,0.1c0.6,0,1.3-0.2,1.9-0.4c0.5-0.2,1.1-0.5,1.5-0.8 c0.8-0.5,1.4-1.1,2.2-1.6h0.1v0.1l0,0c-0.6,0.7-1.1,1.4-1.8,2c-0.4,0.5-1,0.8-1.5,1.2c-0.8,0.4-1.7,0.7-2.6,0.8 c-0.6,0.1-1.3,0.1-1.9,0c-0.7-0.1-1.3-0.3-1.9-0.6c-0.9-0.5-1.6-1.1-2.2-2c-0.3-0.5-0.5-0.9-0.8-1.4c-0.2-0.5-0.4-1-0.5-1.5 c-0.2-0.6-0.3-1.3-0.4-1.9C114.9,232.7,114.9,232.2,115.1,231.8C114.9,231.7,115,231.7,115.1,231.8 C115,231.7,115,231.7,115.1,231.8C115,231.7,115.1,231.8,115.1,231.8L115.1,231.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_338_00000000910691925902194700000003833427214869857705_",
    gradientUnits: "userSpaceOnUse",
    x1: -886.5651,
    y1: -1375.9935,
    x2: -904.1601,
    y2: -1414.1106,
    gradientTransform: "matrix(12.979 0 0 6.8452 11433.4561 9443.4707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_338_00000000910691925902194700000003833427214869857705_)"
    },
    d: " M113.4,242.3c0.1,0.3,0.3,0.6,0.5,0.9c0.3,0.5,0.6,0.9,0.9,1.3c0.4,0.5,0.7,0.9,1.2,1.3c0.4,0.4,0.8,0.7,1.3,1 c0.3,0.2,0.6,0.3,1,0.4c0.4,0.1,0.7,0.2,1.1,0.2c0.8,0.1,1.6,0,2.3-0.1c0.6-0.1,1.3-0.3,1.9-0.5c0.9-0.3,1.8-0.8,2.6-1.4h0.1v0.1 l0,0c-0.7,0.8-1.4,1.5-2.3,2c-0.9,0.6-1.9,1-3,1.3c-0.8,0.2-1.6,0.2-2.4,0.1c-0.8-0.1-1.6-0.5-2.3-0.9c-0.5-0.3-0.9-0.7-1.2-1.2 c-0.5-0.6-0.8-1.3-1.1-2c-0.2-0.4-0.3-0.8-0.5-1.3c-0.1-0.4-0.2-0.9-0.3-1.3C113.3,242.3,113.3,242.2,113.4,242.3 C113.3,242.2,113.3,242.2,113.4,242.3C113.4,242.2,113.4,242.2,113.4,242.3L113.4,242.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_339_00000029749138749591237870000008515823257749859207_",
    gradientUnits: "userSpaceOnUse",
    x1: -859.8624,
    y1: -1370.8441,
    x2: -882.0103,
    y2: -1399.7072,
    gradientTransform: "matrix(10.3089 0 0 9.0439 8859.999 12609.5088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_339_00000029749138749591237870000008515823257749859207_)"
    },
    d: " M76,294.8c-0.6,0.3-1.2,0.6-1.9,0.9c-0.9,0.4-1.8,0.8-2.8,1.3c-0.6,0.3-1.2,0.6-1.7,0.9c-0.4,0.2-0.7,0.4-1.1,0.7 c-0.2,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,0.4-0.4,0.9-0.1,1.3c0.4,0.6,0.9,1.2,1.5,1.6c0.3,0.3,0.7,0.5,1,0.7 s0.7,0.5,1.1,0.7c0,0,0.1,0.1,0,0.1l0,0h-0.1l0,0c-0.4-0.1-0.8-0.3-1.2-0.4c-0.4-0.1-0.8-0.3-1.2-0.5c-0.7-0.3-1.3-0.7-1.8-1.2 c-0.2-0.2-0.5-0.5-0.6-0.8c-0.4-0.7-0.4-1.7,0.1-2.4c0.1-0.2,0.3-0.4,0.5-0.6c0.3-0.2,0.5-0.4,0.8-0.6c0.4-0.2,0.8-0.5,1.3-0.7 c0.7-0.3,1.3-0.5,2-0.7c0.8-0.3,1.7-0.4,2.6-0.6c0.9-0.2,1.7-0.3,2.6-0.5C76,294.7,76.1,294.7,76,294.8 C76.1,294.8,76.1,294.8,76,294.8C76.1,294.8,76,294.8,76,294.8L76,294.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_340_00000159435861733537722290000006952357620194045095_",
    gradientUnits: "userSpaceOnUse",
    x1: -870.1665,
    y1: -1378.7252,
    x2: -888.4386,
    y2: -1399.0972,
    gradientTransform: "matrix(12.504 0 0 12.8142 10946.4287 17950.8301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_340_00000159435861733537722290000006952357620194045095_)"
    },
    d: " M88.1,297.2c-1.7,0.3-3.4,0.8-5,1.5c-0.8,0.3-1.5,0.7-2.2,1.2c-0.7,0.4-1.3,0.9-1.9,1.5c-0.3,0.3-0.7,0.6-0.9,1 c-0.4,0.5-0.8,1.1-1,1.8c-0.4,1.1-0.3,2.3,0.2,3.4c0.2,0.4,0.5,0.8,0.8,1.2c0.3,0.4,0.6,0.7,1,1.1v0.1l0,0H79 c-0.4-0.3-0.8-0.6-1.2-0.9c-0.4-0.3-0.7-0.7-1-1.1c-0.8-1.2-1.1-2.6-0.9-4.1c0.1-0.8,0.5-1.6,0.9-2.3c0.3-0.5,0.7-0.9,1.1-1.3 c0.7-0.6,1.5-1.1,2.3-1.5s1.7-0.7,2.6-1c1.8-0.4,3.6-0.6,5.5-0.6C88.1,297.1,88.1,297.1,88.1,297.2L88.1,297.2L88.1,297.2 L88.1,297.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_341_00000159448080808445360150000014067606614358726847_",
    gradientUnits: "userSpaceOnUse",
    x1: -859.7793,
    y1: -1371.4083,
    x2: -882.4093,
    y2: -1401.3623,
    gradientTransform: "matrix(10.0977 0 0 8.7168 8684.1553 12152.4082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_341_00000159448080808445360150000014067606614358726847_)"
    },
    d: " M99.7,301.2c-0.3,0-0.6,0-0.9,0c-0.7,0.2-1.5,0.4-2.2,0.7c-0.9,0.3-1.7,0.6-2.6,1c-0.4,0.2-0.8,0.4-1.1,0.6 c-0.3,0.2-0.7,0.4-1,0.7c-0.8,0.6-1.1,1.7-0.7,2.7c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.3,0.4,0.5,0.5 c0.3,0.3,0.6,0.5,1,0.7v0.1l0,0h-0.1l0,0c-0.4-0.1-0.8-0.3-1.2-0.5c-0.3-0.1-0.5-0.3-0.7-0.5s-0.4-0.4-0.6-0.6s-0.4-0.4-0.5-0.7 c-0.9-1.3-0.7-3,0.4-4.1c0.2-0.3,0.5-0.5,0.8-0.7c0.4-0.3,0.9-0.5,1.3-0.7c0.6-0.2,1.2-0.4,1.8-0.5c0.6-0.1,1.2-0.2,1.8-0.3 c0.5,0,1.3-0.2,2-0.2c0.5,0,1,0.1,1.4,0.2C99.8,301.1,99.8,301.2,99.7,301.2C99.8,301.2,99.8,301.2,99.7,301.2 C99.8,301.2,99.8,301.3,99.7,301.2L99.7,301.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_342_00000180327842454456727410000011368252110907955074_",
    gradientUnits: "userSpaceOnUse",
    x1: -878.3916,
    y1: -1374.5619,
    x2: -899.7076,
    y2: -1423.6879,
    gradientTransform: "matrix(10.7132 0 0 5.3167 9216.5586 7305.7695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_342_00000180327842454456727410000011368252110907955074_)"
    },
    d: " M50.5,269.2c-0.1,0.4-0.3,0.7-0.6,1c-0.4,0.5-0.8,0.9-1.2,1.2c-0.4,0.4-0.8,0.8-1.2,1.2c-0.3,0.3-0.6,0.5-0.9,0.7 c-0.3,0.2-0.7,0.4-1.1,0.6c-0.6,0.2-1.2,0.4-1.8,0.5c-0.4,0.1-0.9,0-1.3,0c-1-0.2-1.9-0.7-2.5-1.5v-0.1l0,0H40 c1,0.7,2.3,0.9,3.4,0.4c0.5-0.2,0.9-0.4,1.4-0.7c0.3-0.2,0.6-0.3,0.9-0.5s0.6-0.4,0.9-0.5c0.5-0.3,1-0.6,1.4-0.8 c0.5-0.3,1.2-0.6,1.8-1C50,269.6,50.2,269.4,50.5,269.2C50.4,269.1,50.5,269.1,50.5,269.2C50.5,269.1,50.5,269.1,50.5,269.2 L50.5,269.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_343_00000065034095963528894300000014545607280450826135_",
    gradientUnits: "userSpaceOnUse",
    x1: -899.8964,
    y1: -1389.0557,
    x2: -916.4974,
    y2: -1450.6676,
    gradientTransform: "matrix(13.7557 0 0 4.2366 12089.2197 5786.8447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_343",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_343_00000065034095963528894300000014545607280450826135_)"
    },
    d: " M48.1,279.7c-0.1,0.3-0.3,0.5-0.5,0.7c-0.3,0.3-0.6,0.7-1,1c-0.6,0.6-1.3,1.1-2.1,1.5s-1.7,0.7-2.6,0.9c-0.6,0.1-1.3,0.1-1.9,0 c-0.9-0.1-1.9-0.4-2.7-0.8c-1.4-0.7-2.4-1.8-3-3.2v-0.1l0,0h0.1c0.8,1.1,2,1.9,3.3,2.3c0.8,0.2,1.5,0.3,2.3,0.3c0.5,0,1,0,1.5-0.1 c0.8-0.1,1.5-0.2,2.3-0.5c0.8-0.2,1.5-0.6,2.2-0.9c0.4-0.2,0.8-0.4,1.2-0.6c0.3-0.2,0.5-0.3,0.7-0.5 C48,279.6,48.1,279.6,48.1,279.7C48.1,279.6,48.1,279.6,48.1,279.7C48.1,279.6,48.1,279.7,48.1,279.7L48.1,279.7L48.1,279.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_344_00000003797930212658194010000010533043319033376683_",
    gradientUnits: "userSpaceOnUse",
    x1: -891.8494,
    y1: -1385.6984,
    x2: -909.8893,
    y2: -1430.9854,
    gradientTransform: "matrix(12.6641 0 0 5.769 11055.5469 7965.7393)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_344_00000003797930212658194010000010533043319033376683_)"
    },
    d: " M46,288.5c-0.1,0.1-0.2,0.1-0.2,0.2c-0.2,0.2-0.3,0.5-0.5,0.6l-1.6,1.8c-0.4,0.4-0.8,0.7-1.2,1.1c-0.4,0.3-0.9,0.7-1.3,0.9 c-0.3,0.1-0.5,0.3-0.8,0.4c-0.4,0.2-0.9,0.3-1.3,0.4c-0.8,0.2-1.6,0.2-2.3,0.1c-1.2-0.1-2.3-0.5-3.2-1.2v-0.1l0,0h0.1l0,0 c1.3,0.5,2.7,0.5,4.1,0.1c0.6-0.2,1.1-0.4,1.6-0.6c0.3-0.2,0.7-0.3,1-0.5c0.4-0.2,0.9-0.5,1.3-0.7c0.4-0.3,0.9-0.5,1.3-0.8 l2.1-1.3c0.2-0.1,0.4-0.3,0.7-0.5c0.1-0.1,0.2-0.1,0.4-0.2C45.9,288.4,46,288.4,46,288.5L46,288.5L46,288.5L46,288.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_345_00000111903629996977932510000008820428853849282205_",
    gradientUnits: "userSpaceOnUse",
    x1: -942.3658,
    y1: -1414.5266,
    x2: -943.5588,
    y2: -1417.7797,
    gradientTransform: "matrix(191.4623 0 0 80.2114 180152.75 113410.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_345_00000111903629996977932510000008820428853849282205_)"
    },
    d: " M-11.7,397.9c0.5,0.2,1,0,1.3-0.3c1.2-1.4,2.3-2.8,3.5-4.3c22.1-27,43-52.6,103-49.6c34.9,1.7,69.4-10.9,82.5-24.1 c0.4-0.4,0.4-1.1,0-1.5c0,0-0.1,0-0.1-0.1c-0.5-0.4-1.2-0.4-1.7,0c-12.8,12.9-46.5,25.2-80.8,23.5c-61.3-3.1-82.5,22.9-104.9,50.4 c-1.2,1.4-2.3,2.8-3.5,4.3c-0.4,0.5-0.3,1.1,0.2,1.5c0,0,0,0,0.1,0C-12,397.8-11.8,397.8-11.7,397.9L-11.7,397.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_346_00000166666423258255799280000006574426567806784169_",
    gradientUnits: "userSpaceOnUse",
    x1: -888.1107,
    y1: -1389.1469,
    x2: -902.9666,
    y2: -1406.0349,
    gradientTransform: "matrix(15.3716 0 0 15.4524 13760.1592 21694.1875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_346_00000166666423258255799280000006574426567806784169_)"
    },
    d: " M177.3,319.1c-0.1-0.9-0.5-6-0.6-7.4c-0.1-2.1-0.3-5,1.8-6.3c0.8-0.5,2.2-1.2,3.2-0.3c0.8,0.9,1.2,2.1,1,3.3 c0,0.2-0.2,1.1,0.1,1.2c0.5,0.2,6.1-1.4,7.3,0.3c0.8,1.2-2.7,3.7-2.6,3.9c0.1,0.3,4.9,2.7,4.6,4.4 C191.6,320.1,187.3,320.8,177.3,319.1L177.3,319.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_347_00000093890171482793932670000016728522712082547086_",
    gradientUnits: "userSpaceOnUse",
    x1: -895.9489,
    y1: -1392.6528,
    x2: -908.8258,
    y2: -1407.4399,
    gradientTransform: "matrix(17.7343 0 0 17.6477 15994.1289 24801.7988)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_347_00000093890171482793932670000016728522712082547086_)"
    },
    d: " M176.1,319.1c0-0.3-0.1-0.9-0.1-1.6c-0.1-1.9-0.4-4.8-0.4-5.8c-0.1-2.2-0.3-5.6,2.3-7.2c1.8-1.1,3.5-1.2,4.7-0.1 c1,1.1,1.5,2.6,1.4,4.1c2.3-0.4,5.9-0.9,7.2,1c1,1.5-0.6,3.2-1.9,4.3c1.8,1.2,4.4,2.9,4,4.8c-0.7,2.9-5.9,3.5-16,1.7 c-0.1,0-0.1,0-0.2-0.1C176.5,320,176.2,319.6,176.1,319.1L176.1,319.1z M190.9,318c-0.1-0.3-0.6-1-3.1-2.6 c-0.9-0.6-1.3-0.8-1.4-1.3c-0.2-0.7,0.2-1,0.9-1.7c0.7-0.6,1.3-1.2,1.8-2c-0.4-0.2-1.4-0.3-4.6,0.2c-1.2,0.2-1.6,0.2-2,0 c-1-0.4-0.9-1.6-0.8-2.2v-0.1c0.1-0.9-0.1-1.8-0.6-2.5c-0.3-0.2-1.1,0-1.7,0.4c-1.6,1-1.5,3.6-1.3,5.4c0.1,1.1,0.3,3.9,0.4,5.8 c0,0.3,0,0.5,0.1,0.7C190.2,320.1,190.9,318,190.9,318L190.9,318L190.9,318z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_348_00000121958429181540262190000004189238839090014622_",
    gradientUnits: "userSpaceOnUse",
    x1: -927.7896,
    y1: -1407.6804,
    x2: -934.6705,
    y2: -1437.7355,
    gradientTransform: "matrix(33.1769 0 0 8.6885 30578.8457 12143.3926)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_348",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_348_00000121958429181540262190000004189238839090014622_)"
    },
    d: " M152.3,334.4c0.3,0.1,0.5,0.1,0.8,0c0.4-0.1,0.8-0.1,1.2-0.1c0.2,0,0.4,0,0.7,0c1.9-0.1,3.9-0.1,5.8,0.1c5,0.6,9.9,1.8,14.7,3.5 c0.5,0.2,1,0.3,1.6,0.5c2,0.6,4,1.3,6,2.2c0.6,0.3,1.3,0.1,1.5-0.5s0-1.2-0.6-1.5l0,0c-2-0.9-4.1-1.6-6.2-2.3 c-0.5-0.2-1-0.3-1.6-0.5c-4.9-1.8-10.1-3-15.3-3.6c-2.1-0.2-4.2-0.2-6.3-0.1c-0.2,0-0.4,0-0.6,0c-0.6,0-1.2,0.1-1.8,0.2 c-0.5,0.1-0.9,0.7-0.7,1.3v0.1C151.7,334,152,334.3,152.3,334.4L152.3,334.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_349_00000117659527659526943320000008136032200880487066_",
    gradientUnits: "userSpaceOnUse",
    x1: -878.5092,
    y1: -1384.5605,
    x2: -897.1111,
    y2: -1408.6315,
    gradientTransform: "matrix(12.2762 0 0 10.8633 10838.0654 15226.9023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_349",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_349_00000117659527659526943320000008136032200880487066_)"
    },
    d: " M183.5,339.4c1.7-1.1,3.7-3.4,6.1-3.6c4.6-0.3,7.3,4.7,4,5.1c-0.4,0.1-1.4,0-1.8,0.2c-0.2,0.1,1.1,1.1,1.2,1.2 c0.7,0.6,1.1,1.5,1,2.4c-0.3,1.2-1.8,1.5-3.3,0.6c-0.3-0.2-1.4-1.1-1.7-1c-0.4,0.1-0.4,0.8-0.5,1.1c-0.3,0.8-1.1,1.3-2,1.2 c-1.2-0.2-2.2-0.8-2.9-1.7C182.1,343.2,183.2,341.1,183.5,339.4L183.5,339.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_350_00000084511019739672444340000015631820178869247162_",
    gradientUnits: "userSpaceOnUse",
    x1: -889.074,
    y1: -1389.4835,
    x2: -904.69,
    y2: -1409.4995,
    gradientTransform: "matrix(14.6297 0 0 13.0591 13063.3955 18335.1934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_350",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_350_00000084511019739672444340000015631820178869247162_)"
    },
    d: " M182.7,345.6c-1.5-1.9-1-4-0.5-5.5c0.1-0.3,0.2-0.6,0.2-0.9c0.1-0.3,0.2-0.5,0.4-0.6c0.4-0.3,0.8-0.6,1.3-1 c1.5-1.2,3.3-2.6,5.4-2.8c3.5-0.3,6.4,2.1,6.8,4.4c0.3,1.3-0.6,2.5-1.8,2.8h-0.1c0.8,0.8,1.2,2,1,3.1c-0.2,0.8-0.8,1.4-1.6,1.7 c-1.2,0.3-2.4,0.2-3.4-0.5c-0.2-0.1-0.4-0.2-0.5-0.4l0,0c-0.5,1.3-1.8,2.1-3.2,1.8c-0.4,0-0.8-0.1-1.1-0.2 C184.3,347.1,183.4,346.4,182.7,345.6L182.7,345.6z M191.1,344.3c0.1,0.1,0.2,0.2,0.3,0.2c0.4,0.3,0.9,0.4,1.4,0.3 c0.1,0,0.2-0.2,0.3-0.3c0-0.5-0.3-1-0.7-1.4c0,0-0.1-0.1-0.2-0.2c-0.8-0.6-1.4-1.1-1.4-1.8c0-0.3,0.2-0.7,0.5-0.9 c0.6-0.3,1.2-0.4,1.9-0.4c0.1,0,0.3,0,0.4,0c0.5-0.1,0.5-0.2,0.5-0.5c-0.2-0.9-1.7-2.6-4.1-2.4c-1.4,0.1-2.9,1.3-4.2,2.3 c-0.4,0.3-0.7,0.6-1.1,0.8c-0.1,0.2-0.1,0.4-0.2,0.6c-0.4,1.6-0.7,2.7,0.1,3.6c0.5,0.7,1.2,1.1,2,1.3c0.4,0.1,0.7-0.1,0.8-0.5 c0-0.1,0-0.1,0-0.2c0.1-0.7,0.5-1.3,1.2-1.6c0.3-0.1,0.7-0.1,1,0C190.2,343.6,190.6,343.9,191.1,344.3L191.1,344.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_351_00000098926177827053931890000004627973528348968862_",
    gradientUnits: "userSpaceOnUse",
    x1: -920.6196,
    y1: -1403.6345,
    x2: -927.1215,
    y2: -1411.5106,
    gradientTransform: "matrix(35.11 0 0 33.146 32373.7617 46754.4844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_351",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_351_00000098926177827053931890000004627973528348968862_)"
    },
    d: " M118.5,342.7c0.3,0.1,0.7,0.1,1-0.1l0.2-0.2c7.9-4.8,16-9.8,22.5-16.5c2.2-2.4,4.1-5.1,5.8-7.9c0.4-0.7,0.9-1.4,1.3-2.1 s1-1.4,1.5-2.1c0.6-0.8,1.2-1.6,1.8-2.5c0.3-0.5,0.1-1.2-0.4-1.5l0,0c-0.5-0.3-1.2-0.2-1.6,0.3c-0.5,0.8-1.1,1.6-1.7,2.3 c-0.5,0.7-1.1,1.5-1.6,2.2s-0.9,1.4-1.3,2.1c-1.6,2.7-3.4,5.3-5.5,7.6c-6.3,6.5-14.3,11.4-22,16.1l-0.2,0.2 c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0.1,0.1,0.1C118.1,342.5,118.3,342.7,118.5,342.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_352_00000043446216860470679610000009737391325010672262_",
    gradientUnits: "userSpaceOnUse",
    x1: -868.9528,
    y1: -1381.5344,
    x2: -887.4778,
    y2: -1400.1575,
    gradientTransform: "matrix(12.3285 0 0 14.0103 10854.1904 19645.1992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_352_00000043446216860470679610000009737391325010672262_)"
    },
    d: " M151.9,310.8c-3.8-3.6-2.5-9.4-1.3-11.4c0.5-0.8,1.6-2.1,2.7-1.4c0.8,0.6,1.3,1.5,1.4,2.6c0,0.2-0.1,1.2,0.1,1.3 c0.3,0.2,0.9-0.2,1.1-0.3c0.9-0.4,3.2-1.5,3.9-0.2c0.6,1.1-0.3,2.6-0.9,3.5c-0.2,0.3-0.8,0.7-0.8,1.1c0,0.3,0.5,0.7,0.7,0.9 c0.7,0.7,3.6,2.8,2.6,3.8C161,311.2,157.2,312.9,151.9,310.8L151.9,310.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_353_00000096033774744277613880000013349268153750320047_",
    gradientUnits: "userSpaceOnUse",
    x1: -882.0163,
    y1: -1386.9116,
    x2: -897.5643,
    y2: -1403.0206,
    gradientTransform: "matrix(14.695 0 0 16.1982 13091.7012 22742.4609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_353_00000096033774744277613880000013349268153750320047_)"
    },
    d: " M151.5,311.8c-0.2-0.1-0.3-0.1-0.4-0.3c-4.3-4.1-2.9-10.5-1.5-12.7c0.5-1,1.4-1.7,2.5-2.1c0.7-0.1,1.3,0,1.9,0.4 c1.1,0.7,1.8,1.9,1.9,3.3c1.1-0.6,2.4-0.8,3.7-0.6c0.6,0.2,1.1,0.6,1.4,1.1c0.7,1.2,0.4,2.8-1,4.6c-0.1,0.1-0.2,0.3-0.4,0.4l0,0 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.3,0.3,0.5,0.5c1.3,1.2,2.6,2.3,2.6,3.5c0,0.5-0.1,1-0.5,1.3c-0.9,0.8-4.9,2.5-10.3,0.6 C151.9,312,151.7,311.9,151.5,311.8L151.5,311.8z M151.9,310.8L151.9,310.8z M158.7,308.2c-0.3-0.3-0.5-0.5-0.7-0.6l-0.1-0.1 c-0.9-0.5-1.2-1.6-0.7-2.4c0.1-0.3,0.4-0.5,0.6-0.6c0.1-0.1,0.1-0.1,0.2-0.2c0.9-1.2,1-2,0.9-2.3c-0.2,0-0.7-0.1-2.2,0.6l-0.3,0.1 c-0.6,0.4-1.4,0.5-2.2,0.2c-0.6-0.5-0.9-1.3-0.7-2.1c0-0.1,0-0.1,0-0.2c0-0.7-0.3-1.3-0.8-1.7c-0.5,0.2-0.8,0.6-1,1 c-0.9,1.5-2.3,6.8,0.9,9.9c4.1,1.5,7.1,0.5,7.9,0.1C160,309.3,159.4,308.7,158.7,308.2L158.7,308.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_354_00000005967064728117449910000002280351251721935292_",
    gradientUnits: "userSpaceOnUse",
    x1: -933.7888,
    y1: -1411.5605,
    x2: -938.2548,
    y2: -1424.4775,
    gradientTransform: "matrix(51.1221 0 0 20.2183 47475.3633 28479.9863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_354_00000005967064728117449910000002280351251721935292_)"
    },
    d: " M121.5,361.8c0.4,0.2,0.9,0.1,1.3-0.3s0.3-1.1-0.1-1.5c0,0,0,0-0.1-0.1c-4.5-3.6-10-5.9-15.4-8.1l-0.2-0.1 c-10.9-4.5-22.2-7.9-33.8-10.1c-0.6-0.1-1.2,0.2-1.3,0.8l0,0c-0.1,0.6,0.4,1.2,1,1.3c11.4,2.2,22.6,5.5,33.3,9.9l0.2,0.1 c5.2,2.1,10.5,4.3,14.7,7.7C121.2,361.7,121.4,361.8,121.5,361.8L121.5,361.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_355_00000170997421529247473400000012621959917266827670_",
    gradientUnits: "userSpaceOnUse",
    x1: -872.622,
    y1: -1382.6149,
    x2: -891.064,
    y2: -1402.726,
    gradientTransform: "matrix(12.3806 0 0 12.9802 10875.4209 18244.793)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_355",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_355_00000170997421529247473400000012621959917266827670_)"
    },
    d: " M122,360.2c0.9-2.7,9.1-6.1,11.2-3c0.7,1,0.6,2.3-0.1,3.2c-0.4,0.5-1,1-1,1.7c0.1,1.6,1.9,2.8,1.2,4.4c-0.6,1.3-2.2,1.8-3.4,1.2 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.2-1.1-1-1.6-0.9c-0.5,0.1-0.8,0.6-1,1c-0.4,0.6-0.9,1-1.5,1.2 C122.6,369.8,120.1,363.2,122,360.2L122,360.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_356_00000105417561627025295940000011732672118364331171_",
    gradientUnits: "userSpaceOnUse",
    x1: -884.8637,
    y1: -1387.9791,
    x2: -900.3497,
    y2: -1405.1761,
    gradientTransform: "matrix(14.7496 0 0 15.1755 13115.2979 21352.3984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_356",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_356_00000105417561627025295940000011732672118364331171_)"
    },
    d: " M122.2,368.6c-1.9-2.1-2.8-6.4-1.2-8.9c1-2.4,5.5-4.6,8.7-4.8c2.1-0.1,3.7,0.5,4.6,1.8c0.9,1.3,0.9,3.1-0.1,4.4 c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1,0.2-0.4,0.5-0.4,0.6c0.1,0.5,0.3,1,0.6,1.4c0.8,1,1,2.3,0.6,3.5c-0.4,0.9-1.2,1.6-2.1,1.9 c-1.1,0.3-2.3,0.2-3.3-0.4c-0.2-0.1-0.5-0.3-0.7-0.5c0,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.1,0.2-0.2,0.2l-0.1,0.1 c-0.5,0.7-1.2,1.3-2.1,1.6c-0.6,0.2-1.3,0.2-2,0C123.3,369.6,122.7,369.2,122.2,368.6L122.2,368.6z M130,366.5 c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.2,0.9,0.3,1.4,0.2c0.3-0.1,0.6-0.4,0.8-0.7c0.2-0.5,0-0.9-0.5-1.7c-0.5-0.7-0.7-1.5-0.8-2.3 c0-0.8,0.3-1.5,0.9-2c0.1-0.1,0.2-0.2,0.3-0.3c0.5-0.6,0.5-1.4,0.1-2.1c-0.4-0.7-1.5-0.7-2.3-0.7c-2.8,0.2-6.3,2.2-6.8,3.5 c0,0.1-0.1,0.1-0.1,0.2c-1.1,1.7-0.4,5,0.9,6.5c0.6,0.7,1,0.6,1.1,0.5c0.4-0.2,0.7-0.5,1-0.8l0.1-0.1c0.4-0.6,1-1.1,1.7-1.3 c0.3,0,0.6,0,0.9,0.1C129.2,365.9,129.6,366.1,130,366.5L130,366.5z M120.9,359.8L120.9,359.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_357_00000147912999375341929090000012153300622074031261_",
    gradientUnits: "userSpaceOnUse",
    x1: -907.796,
    y1: -1397.2992,
    x2: -916.863,
    y2: -1407.1842,
    gradientTransform: "matrix(25.1832 0 0 26.407 22904.2988 37227.1562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_357_00000147912999375341929090000012153300622074031261_)"
    },
    d: " M39.9,351.6c0.3,0.1,0.5,0.1,0.8,0c3.5-1.2,6.5-4.1,8.8-6.3c5.6-5.5,10.5-11.7,14.6-18.3c0.3-0.5,0.1-1.2-0.4-1.5l0,0 c-0.5-0.3-1.2-0.2-1.6,0.3c-4,6.6-8.8,12.6-14.3,17.9c-2.1,2-5,4.8-8,5.8c-0.5,0.2-0.8,0.7-0.7,1.3v0.1 C39.3,351.2,39.5,351.4,39.9,351.6L39.9,351.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_358_00000105422072185811227360000018117248538124312494_",
    gradientUnits: "userSpaceOnUse",
    x1: -867.4607,
    y1: -1376.4829,
    x2: -887.0698,
    y2: -1399.646,
    gradientTransform: "matrix(11.7025 0 0 11.2661 10173.293 15777.8789)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_358_00000105422072185811227360000018117248538124312494_)"
    },
    d: " M62.8,326.2c0,0.1-1.5-2.2-1.5-2.2c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.2-1.1-0.3-1.6c-0.3-1.7,0.1-3.4,1.2-4.7 c1.2-1.2,2.6-1,3.3,0.6c0.1,0.2,0.3,1.4,0.6,1.4c0.4,0,0.9-0.4,1.3-0.5c1.2-0.6,3.4-1.8,4.7-0.7c0.4,0.4,0.6,0.9,0.5,1.5 c-0.1,1.4-1.5,2.1-1.8,3.3c-0.4,1.2,1.2,2.3,1.3,3.5c0.1,1-0.8,1.5-1.8,1.5C68.3,327.5,64.5,326.3,62.8,326.2L62.8,326.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_359_00000121274219232251083940000010415118630922396296_",
    gradientUnits: "userSpaceOnUse",
    x1: -880.806,
    y1: -1383.0813,
    x2: -897.113,
    y2: -1402.4703,
    gradientTransform: "matrix(14.0704 0 0 13.4526 12412.1309 18873.0547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_359_00000121274219232251083940000010415118630922396296_)"
    },
    d: " M60.1,324.1l-0.1-0.5c-0.1-0.6-0.2-1.1-0.3-1.7c-0.4-2,0.1-4,1.4-5.5c0.7-0.8,1.8-1.2,2.9-1c1.1,0.3,1.9,1,2.3,2.1 c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0,0.1-0.1l0.2-0.1c1.4-0.7,3.9-2,5.9-0.5c0.7,0.6,1,1.5,0.9,2.4c-0.1,0.9-0.5,1.8-1.2,2.5 c-0.3,0.3-0.5,0.7-0.7,1.1c-0.1,0.2,0.2,0.7,0.5,1.1c0.4,0.6,0.7,1.3,0.9,2c0.1,0.7-0.2,1.4-0.7,1.9c-0.6,0.5-1.4,0.8-2.3,0.7 c-1.2-0.1-2.4-0.4-3.6-0.7c-1.2-0.3-2.4-0.5-3.6-0.7c-0.1,0-0.2,0-0.4,0c0,0,0,0-0.1,0C61.5,326.9,60.1,324.2,60.1,324.1z  M71.2,318.7c-0.7-0.5-2.4,0.4-3.2,0.8l-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.5,0.4-1.1,0.6-1.7,0.5c-1.1-0.1-1.4-1.2-1.6-1.9 c0-0.1,0-0.2,0-0.2c-0.2-0.5-0.4-0.6-0.5-0.7s-0.4,0.1-0.8,0.5c-1,1-1,2.9-0.9,3.8c0.1,0.5,0.1,1,0.3,1.5l0.1,0.4 c0.2,0.3,0.7,1,1,1.5c1.2,0.2,2.4,0.4,3.5,0.7c1.1,0.3,2.1,0.5,3.2,0.6c0.2,0,0.4,0,0.5-0.1s0.1-0.1,0.1-0.2 c-0.1-0.4-0.3-0.7-0.5-1c-0.7-0.8-0.9-1.8-0.8-2.8c0.2-0.7,0.6-1.3,1.1-1.8c0.4-0.4,0.6-0.8,0.8-1.4 C71.2,319,71.2,318.8,71.2,318.7L71.2,318.7L71.2,318.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_360_00000181800612492664769370000018307767711630505350_",
    gradientUnits: "userSpaceOnUse",
    x1: -943.1637,
    y1: -1416.7302,
    x2: -944.3037,
    y2: -1422.2423,
    gradientTransform: "matrix(200.3723 0 0 47.3318 188580.5625 66904.4219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_360_00000181800612492664769370000018307767711630505350_)"
    },
    d: " M-13,396.1c4.1-3.7,8.3-7.2,12.8-10.4c4.6-3.3,9.5-6.1,14.6-8.4c3-1.4,6.1-2.5,9.2-3.5c2.2-0.7,4.4-1.2,6.6-1.5 c9-1.2,18.1-0.8,27,1.1c8.9,1.8,17.6,4.7,25.7,8.7c2.7,1.3,5.4,2.8,8,4.3c10.3,5.9,19.9,12.9,30.6,18.2 c9.9,4.8,20.4,8.3,31.2,10.2c11.1,2,22.4,2.5,32.4,0.9c0.6-0.1,1.3,0.3,1.4,0.9c0.1,0.6-0.2,1.1-0.8,1.3h-0.1 c-10.4,1.7-21.9,1.4-33.3-0.6c-11.1-1.9-21.9-5.3-32.1-10.2c-10.8-5.3-20.6-12.1-30.9-18c-2.6-1.4-5.1-2.8-7.8-4.1 c-7.9-3.8-16.2-6.5-24.8-8.1c-8.4-1.7-17.1-2-25.6-0.8c-2.6,0.4-5.1,1.1-7.5,1.9c-2.5,0.9-4.9,1.9-7.3,2.9 c-4.9,2.2-9.5,5-13.9,8.1c-4.3,3.2-8.4,6.6-12.3,10.2c-0.9,0.8-2.3,0.7-3.1-0.1c-0.8-0.7-0.9-2-0.2-2.8 C-13.1,396.2-13.1,396.2-13,396.1L-13,396.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_361_00000001647675021584934110000013003724724385646727_",
    gradientUnits: "userSpaceOnUse",
    x1: -933.877,
    y1: -1413.5592,
    x2: -938.599,
    y2: -1426.6802,
    gradientTransform: "matrix(48.362 0 0 19.8843 44976.7109 28070.0957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_361_00000001647675021584934110000013003724724385646727_)"
    },
    d: " M191.1,421c-2.2-0.8-4.3-1.8-6.3-2.9c-0.3-0.2-0.5-0.5-0.6-0.8s0.1-0.7,0.3-0.9c4.8-4.4,9.6-8.4,16-10.5c5.2-1.6,12-1.6,18.7,0.2 c2.4,0.7,4.8,1.6,7.1,2.7c0.8,0.4,1.6,0.7,2.5,1.1c0.3,0.1,0.7,0.3,1.2,0.5c2,0.8,2.5,1,2.5,1.8c-0.1,0.9-0.9,1-2.2,1.1 c-0.6,0-1.5,0.1-1.9,0.1c-1.6,0.4-3.2,1.2-4.5,2.3c-0.9,0.7-1.7,1.4-2.5,2.2c-0.7,0.7-1.4,1.3-2.2,1.9c-2.1,1.6-4.5,2.9-7.1,3.8 c-5.8,2-12.5,0.4-18.6-1.8C192.8,421.6,191.9,421.3,191.1,421L191.1,421z M225.5,410.8c-2.2-1.1-4.4-1.9-6.7-2.6 c-6.2-1.6-12.7-1.7-17.3-0.2c-5.5,1.8-9.9,5.2-14.1,9c1.5,0.8,3,1.4,4.5,2c6.3,2.4,13.6,4.7,19.4,2.6c2.3-0.8,4.5-2,6.4-3.4 c0.7-0.6,1.4-1.2,2.1-1.8c0.9-0.8,1.8-1.6,2.7-2.3c1.4-1.1,2.9-1.9,4.6-2.5C226.5,411.3,226,411.1,225.5,410.8L225.5,410.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_362_00000054231207985494445260000008926625382440510355_",
    gradientUnits: "userSpaceOnUse",
    x1: -912.1721,
    y1: -1402.5431,
    x2: -920.1981,
    y2: -1409.61,
    gradientTransform: "matrix(28.4516 0 0 36.9297 26124.9004 52183.6055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_362_00000054231207985494445260000008926625382440510355_)"
    },
    d: " M168.3,417.6c-0.3-0.2-0.5-0.5-0.5-0.9c-0.3-6.4-0.4-12.6,2.2-18.5c2.1-4.7,6.6-9.2,12.3-12.5c2.2-1.1,4.4-2.1,6.8-2.8 c0.8-0.3,1.7-0.6,2.5-0.9c0.3-0.1,0.7-0.3,1.2-0.5c1.9-0.8,2.4-1,3-0.3c0.7,0.7,0.2,1.3-0.6,2.3c-0.4,0.4-0.8,0.9-1.1,1.4 c-0.7,1.4-1.1,3-1.1,4.7c0,1.1,0,2.2,0.1,3.3c0.1,0.9,0.1,1.9,0.1,2.9c-0.1,2.6-0.6,5.2-1.6,7.6c-2.5,6.1-9.4,9.5-15.8,12.3 c-2,0.9-4.2,1.6-6.3,2.1C169,417.8,168.6,417.8,168.3,417.6L168.3,417.6z M190,385c-2.2,0.7-4.3,1.6-6.4,2.6 c-5.4,3-9.5,7.2-11.4,11.5c-2.2,5-2.4,10.5-2.1,16.1c1.5-0.4,3-1,4.5-1.6c6-2.6,12.5-5.7,14.7-11.2c0.9-2.2,1.4-4.5,1.5-6.9 c0-0.9,0-1.8-0.1-2.8c-0.1-1.2-0.1-2.3-0.1-3.5c0-1.7,0.4-3.4,1-4.9C191.1,384.6,190.6,384.8,190,385L190,385z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_363_00000018920316913986621500000015272935877140814773_",
    gradientUnits: "userSpaceOnUse",
    x1: -912.6567,
    y1: -1402.9062,
    x2: -920.4587,
    y2: -1409.5732,
    gradientTransform: "matrix(29.2719 0 0 39.1433 26886.9961 55353.6562)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_363_00000018920316913986621500000015272935877140814773_)"
    },
    d: " M180.3,453.9c-0.3-0.5-0.7-1.1-1.1-1.5c-1.2-1.3-2.7-2.2-4.3-2.9c-1.1-0.5-2.2-0.9-3.3-1.3c-1-0.3-2-0.7-3-1.1 c-2.6-1.2-5-2.7-7.1-4.6c-5.4-4.7-6.7-12.2-7.4-18.8c-0.3-2.1-0.3-4.2-0.2-6.4c0-0.3,0.2-0.6,0.5-0.8c0.3-0.2,0.7-0.2,1-0.1 c6.5,2.4,12.8,4.9,17.9,9.6c4.1,3.7,7.2,9.5,8.7,15.9c0.5,2.3,0.7,4.7,0.7,7c0,0.8,0.1,1.7,0.1,2.5c0,0.3,0.1,0.7,0.1,1.2 c0.2,2,0.3,2.5-0.6,2.8c-0.2,0.1-0.5,0.1-0.8,0C181.1,455.2,180.8,454.6,180.3,453.9L180.3,453.9z M156.4,423.5 c0.7,6.2,1.9,13.2,6.7,17.4c1.9,1.7,4.1,3.1,6.4,4.1c0.9,0.4,1.8,0.7,2.8,1.1c1.2,0.4,2.4,0.8,3.5,1.4c1.7,0.7,3.2,1.7,4.6,2.9 c0-0.5,0-1.1-0.1-1.6c0-2.2-0.2-4.4-0.7-6.6c-1.4-5.8-4.4-11.3-8-14.7c-4.4-4-9.8-6.4-15.5-8.5C156.2,420.5,156.2,422,156.4,423.5 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_364_00000018233978199100158770000013152791214749022113_",
    gradientUnits: "userSpaceOnUse",
    x1: -930.0411,
    y1: -1409.6289,
    x2: -935.4331,
    y2: -1420.2959,
    gradientTransform: "matrix(42.3524 0 0 24.4656 39224.3945 34530.5469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_364_00000018233978199100158770000013152791214749022113_)"
    },
    d: " M117.2,401c-0.2-0.3-0.2-0.6-0.1-0.9c0.2-0.6,0.3-1.2,0.4-1.9c0.8-4,2-10.1,14.5-15.2c5.8-2.3,11.8-3.9,17.9-4.7 c3.8-0.5,8.4-0.9,9.2,0c0.3,0.3,0.9,1.1-2,5.8c-3.1,5.1-15.2,21.6-39.1,17.4c-0.1,0-0.1,0-0.2-0.1 C117.5,401.4,117.3,401.2,117.2,401L117.2,401z M133,385c-11.4,4.6-12.5,10.1-13.2,13.7c-0.1,0.3-0.1,0.6-0.2,0.9 c24.2,3.6,34.7-14.9,36.9-19.6C148.5,380.3,140.5,382,133,385L133,385z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_365_00000128472648638488209950000003375447797847841709_",
    gradientUnits: "userSpaceOnUse",
    x1: -930.7374,
    y1: -1421.4646,
    x2: -937.5914,
    y2: -1459.4946,
    gradientTransform: "matrix(33.3122 0 0 6.8572 30738.877 9629.4502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_365_00000128472648638488209950000003375447797847841709_)"
    },
    d: " M184.3,418c0.2,0.1,0.4,0.1,0.6,0.1c2.7-0.3,5.4-0.4,8.1-0.6c3.6-0.2,7.4-0.4,11.1-0.9c4.1-0.7,8.1-1.8,12-3.2 c0.5-0.2,0.8-0.7,0.7-1.3V412c-0.3-0.6-0.9-0.9-1.5-0.7c-3.8,1.4-7.7,2.4-11.6,3.1c-3.6,0.5-7.3,0.7-10.8,0.9 c-2.7,0.1-5.5,0.3-8.2,0.6c-0.6,0-1,0.5-1,1.1v0.1C183.6,417.6,183.9,417.9,184.3,418L184.3,418z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_366_00000118398526071604157150000007638512690164050320_",
    gradientUnits: "userSpaceOnUse",
    x1: -890.5825,
    y1: -1395.1047,
    x2: -903.2244,
    y2: -1405.1858,
    gradientTransform: "matrix(18.051 0 0 25.8931 16286.0537 36566.2812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_366_00000118398526071604157150000007638512690164050320_)"
    },
    d: " M185.9,392.2c-0.5,0.9-1,1.7-1.6,2.5c-1.3,1.9-2.8,3.6-4.1,5.5c-0.9,1.3-1.7,2.6-2.5,3.9c-1.2,2-2.3,4-3.4,6c-1,1.7-2.1,3.4-3,5.1 c-0.4,0.7-0.8,1.5-1.1,2.2c-0.3,0.5-1,0.7-1.6,0.4c-0.6-0.2-0.8-0.9-0.6-1.5l0,0c0.4-0.8,0.9-1.5,1.4-2.3c1.1-1.7,2.3-3.3,3.4-4.9 c1.3-1.9,2.6-3.9,3.9-5.8c0.9-1.3,1.8-2.5,2.8-3.7c1.4-1.8,3.1-3.4,4.5-5.2c0.6-0.7,1.2-1.5,1.8-2.3 C185.8,392.1,185.8,392.1,185.9,392.2C185.9,392.1,185.9,392.1,185.9,392.2L185.9,392.2L185.9,392.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_367_00000026150844300564087400000015911632133707195794_",
    gradientUnits: "userSpaceOnUse",
    x1: -888.8348,
    y1: -1394.3142,
    x2: -901.8018,
    y2: -1404.6442,
    gradientTransform: "matrix(17.6118 0 0 25.2644 15857.4014 35700.4922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_367_00000026150844300564087400000015911632133707195794_)"
    },
    d: " M172.1,441.7c-1.9-3.4-4-6.6-6.3-9.8c-4.3-6-8.1-10.2-9.9-12.3c-0.5-0.5-0.9-1.1-1.2-1.7c-0.2-0.5,0.1-1.1,0.6-1.3h0.1 c0.6-0.2,1.3,0.2,1.5,0.8c0.5,0.9,1.1,1.8,1.8,2.6c1.9,2.5,4.8,6.5,8,11.6c2,3.3,3.9,6.7,5.6,10.2v0.1l0,0 C172.2,441.8,172.1,441.8,172.1,441.7L172.1,441.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_368_00000180363926671287324300000006370582026665588909_",
    gradientUnits: "userSpaceOnUse",
    x1: -925.5323,
    y1: -1408.7501,
    x2: -932.7933,
    y2: -1424.2902,
    gradientTransform: "matrix(31.4483 0 0 16.792 28905.7598 23672.6152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_368",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_368_00000180363926671287324300000006370582026665588909_)"
    },
    d: " M145.1,386.2c-1.3,1.1-2.7,2.2-4.1,3.2c-2.2,1.5-4.5,2.8-6.7,4.1c-2.5,1.4-4.9,2.7-7.4,3.9c-3.8,1.9-7.6,3.6-11.4,5.4 c-0.6,0.2-1.3,0-1.6-0.6c-0.3-0.5-0.1-1.1,0.4-1.4c0,0,0.1,0,0.1-0.1c3.9-1.5,7.9-3.1,11.7-4.7c2.6-1.1,5.1-2.2,7.7-3.4 c2.4-1.1,4.7-2.3,7-3.6c1.5-0.9,2.9-1.8,4.3-2.9C145,386.1,145,386.1,145.1,386.2L145.1,386.2L145.1,386.2L145.1,386.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_369_00000156584922129285228170000012359387872708376508_",
    gradientUnits: "userSpaceOnUse",
    x1: -868.5758,
    y1: -1392.3496,
    x2: -882.9628,
    y2: -1400.0027,
    gradientTransform: "matrix(15.8695 0 0 34.1011 14147.5586 48186.8711)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_369_00000156584922129285228170000012359387872708376508_)"
    },
    d: " M95.3,390.7c0.2,2.2,2.8,9.5,5.7,16.6c2.8,6.9,6,13.8,7.8,16.2c0,0,0,0.1,0,0.2l0,0c-0.1,0-0.1,0-0.2,0c-1.9-2.3-5.5-9.1-8.8-16 c-3.4-7.3-6.5-14.6-6.8-16.9c-0.1-0.6,0.4-1.1,0.9-1.2H94C94.7,389.6,95.2,390,95.3,390.7L95.3,390.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_370_00000038370849404408947970000008109654260311644807_",
    gradientUnits: "userSpaceOnUse",
    x1: -921.5169,
    y1: -1404.0345,
    x2: -928.0579,
    y2: -1412.5386,
    gradientTransform: "matrix(34.9078 0 0 30.6938 32092.1309 43345.2656)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_370",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_370_00000038370849404408947970000008109654260311644807_)"
    },
    d: " M29.2,373.1c0.9,0.6,6.3,2,15.3,10c6.6,6.1,12.6,12.9,17.8,20.2c0,0.1,0,0.1,0,0.2l0,0c-0.1,0-0.1,0-0.2,0 c-5.5-7.1-11.7-13.6-18.6-19.4c-6.6-5.4-11.3-7.5-13.6-8.5c-0.6-0.2-1.3-0.5-1.9-0.8c-0.5-0.3-0.7-1-0.4-1.5c0,0,0,0,0-0.1 C27.9,372.8,28.7,372.7,29.2,373.1L29.2,373.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_371_00000034801797223709911560000005947487442379591594_",
    gradientUnits: "userSpaceOnUse",
    x1: -933.2817,
    y1: -1415.2496,
    x2: -938.5357,
    y2: -1435.4567,
    gradientTransform: "matrix(43.4678 0 0 12.9121 40209.7461 18154.1855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_371",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_371_00000034801797223709911560000005947487442379591594_)"
    },
    d: " M47.8,372.7c6.7-3,13.6-5.5,20.6-7.5c6.6-1.7,12.9-2.5,22-3.3c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1-0.1,0.1l0,0 c-9,1.2-15.2,2.3-21.6,4.2c-6.9,2.2-13.5,5-20,8.3c-0.6,0.3-1.3,0-1.6-0.5s-0.1-1.1,0.3-1.4C47.7,372.7,47.8,372.7,47.8,372.7 L47.8,372.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_372_00000121968538575680894080000004539710966499010452_",
    gradientUnits: "userSpaceOnUse",
    x1: -906.0599,
    y1: -1400.4054,
    x2: -914.4819,
    y2: -1406.7974,
    gradientTransform: "matrix(27.1084 0 0 40.8269 24778.457 57717.1445)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_372",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_372_00000121968538575680894080000004539710966499010452_)"
    },
    d: " M96.1,421c-6.3-6.7-4.3-18.5-1.3-24.7c0.2-0.4,0.6-0.7,1.1-0.6c0.3,0,0.8,0.1,5.3,2.4c1.8,0.9,3.4,2,5,3.3 c7.9,6.4,9.5,15.9,11,24.2c0.2,0.9,0.5,2.6,0.9,4.2c1.3,5.9,1.3,5.9,0.7,6.4c-0.2,0.2-0.5,0.3-0.9,0.3c-0.1,0-0.1,0-0.1,0 C115.4,435.7,97.9,422.9,96.1,421z M97.8,419.6c2.2,2.3,13.8,10.4,18.5,13.5c-0.2-1-0.4-2.1-0.7-3.1c-0.4-1.7-0.7-3.3-0.9-4.3 c-1.4-8-2.9-17-10.1-22.9c-1.4-1.2-3-2.2-4.6-3c-1.7-0.9-2.9-1.5-3.5-1.8C93.6,405.1,93.1,414.6,97.8,419.6L97.8,419.6z  M95.7,397.9L95.7,397.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_373_00000150785331692717065430000007896776289392753592_",
    gradientUnits: "userSpaceOnUse",
    x1: -935.1704,
    y1: -1413.4283,
    x2: -939.3524,
    y2: -1426.7294,
    gradientTransform: "matrix(54.5968 0 0 19.6233 50743.8516 27651.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_373_00000150785331692717065430000007896776289392753592_)"
    },
    d: " M53.4,371.5c-0.2-0.4-0.2-0.8,0.1-1.2c4.5-5.6,10.3-10,17-12.7c6.9-2.6,15.4-3.1,24.3-1.4c1,0.2,1.9,0.4,2.9,0.6 c2,0.4,4.1,0.8,6.1,1.1c0.1,0,0.3,0,0.5,0c1.4,0.1,2.9,0.1,3.4,1.2c0.6,1.3-0.9,2.5-1.7,3.1l-0.2,0.1c-2,1.6-4.3,3.4-6.7,5.2 c-6.4,4.7-14.1,7.3-22,7.3c-3.8-0.2-7.6-0.6-11.3-1.4c-3.7-0.7-7.5-1.2-11.2-1.3c-0.2,0-0.3,0-0.4-0.1 C53.8,372,53.5,371.8,53.4,371.5L53.4,371.5z M104.3,360.1c-0.3,0-0.6,0-0.7-0.1c-2.1-0.3-4.2-0.7-6.3-1.2c-1-0.2-1.9-0.4-2.9-0.6 c-8.5-1.6-16.5-1.2-23,1.3c-5.6,2.3-10.6,5.8-14.6,10.4c2.7,0.2,6,0.8,9.2,1.3c3.6,0.7,7.2,1.1,10.9,1.3c7.4,0,14.7-2.4,20.6-6.8 c2.3-1.8,4.7-3.6,6.7-5.2c0.1,0,0.1-0.1,0.2-0.2s0.3-0.2,0.4-0.3C104.6,360.1,104.4,360.1,104.3,360.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_374_00000022544005017516058820000018103381549722897056_",
    gradientUnits: "userSpaceOnUse",
    x1: -920.1133,
    y1: -1404.1154,
    x2: -926.0742,
    y2: -1410.0443,
    gradientTransform: "matrix(38.3107 0 0 44.0259 35319.0039 62227.8555)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_374",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_374_00000022544005017516058820000018103381549722897056_)"
    },
    d: " M70.6,419.4c-0.2-2.2-5.5-6.2-11.2-10.5c-10.7-8.1-25.3-19.1-24.3-31.5c0-0.3,0.2-0.6,0.5-0.8c0.3-0.2,0.7-0.2,1-0.1 c1.5,0.5,3.1,0.9,4.9,1.3c6.8,1.6,16,3.8,23.9,15c10.3,14.7,7.8,26.5,7.2,27.2c-0.3,0.4-0.8,0.5-1.3,0.4h-0.1 C71,420.3,70.7,419.9,70.6,419.4L70.6,419.4z M41.2,380c-1.3-0.3-2.5-0.6-3.7-0.9c0.2,10.7,13.6,20.8,23.4,28.2 c4.4,3.4,8.1,6.1,10.2,8.5c0.1-4.2-0.8-12.3-7.5-21.8c-3.8-5.7-9.3-10-15.7-12.2C45.6,381.1,43.4,380.5,41.2,380L41.2,380z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_375_00000027596281582680435210000011544634647780273044_",
    gradientUnits: "userSpaceOnUse",
    x1: -938.7203,
    y1: -1413.0171,
    x2: -940.0634,
    y2: -1413.9471,
    gradientTransform: "matrix(170.0606 0 0 280.8145 159906.8906 397275.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_375_00000027596281582680435210000011544634647780273044_)"
    },
    d: " M-12,394.8c1.6-1.4,2.9-3.1,4.1-4.8c3-4.3,5.3-9.2,8.1-13.3c3.8-5.5,7.9-10.5,11.4-16c2.3-3.5,4.2-7.4,5.7-11.4 c2-5.9,3.2-12,3.7-18.3c1.3-14.7-0.3-29.7,1.9-44.6c3.1-21.4,12-40.9,22.6-57.7c13.3-21,29.5-37.6,40.5-47.8 c15.2-14.1,33.1-19.6,48.3-32.9c8.1-7.1,15.4-16.5,21-30.7c0.3-0.6,0.9-0.8,1.5-0.6c0.6,0.2,0.9,0.9,0.7,1.5l0,0 c-5.8,14.6-13.2,24.2-21.5,31.6c-15.1,13.3-32.9,18.9-48.1,33C77,193,61.1,209.5,48,230.3c-10.4,16.5-19.1,35.7-22.1,56.8 c-2.1,14.8-0.5,29.8-1.7,44.5c-0.5,6.4-1.8,12.8-3.8,18.9c-1.5,4.2-3.5,8.2-5.9,11.9C11,367.9,6.9,373,3.1,378.5 c-2.8,4.1-5.1,9-8,13.3c-1.3,2-2.8,3.8-4.6,5.4c-0.7,0.6-1.7,0.6-2.4-0.1c-0.6-0.5-0.7-1.5-0.1-2.1C-12.1,394.9-12,394.9-12,394.8 L-12,394.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_376_00000006707640622459515920000018135520417657376168_",
    gradientUnits: "userSpaceOnUse",
    x1: -882.4524,
    y1: -1391.4716,
    x2: -895.9264,
    y2: -1401.6036,
    gradientTransform: "matrix(16.946 0 0 25.7556 15225.3096 36075.4961)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_376_00000006707640622459515920000018135520417657376168_)"
    },
    d: " M154.7,121.7c0.6-1.7,0.3-3.9,0-5.7c-0.3-2.2-0.6-4.4-1.2-6.5c-0.9-3.6-2-7.4-0.3-10.8c0.3-0.6,0.7-1.2,1.2-1.7 c3-3,5.7,1.5,6.2,4.1c0.1,0.5,0.1,2.2,0.6,2.5c0.3,0.2,2.1-1.8,2.4-2c2.8-2.3,5.8,0.3,5.6,3.4C168.9,112,158.1,116.1,154.7,121.7z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_377_00000173882934512106635950000005958314777989283718_",
    gradientUnits: "userSpaceOnUse",
    x1: -890.5659,
    y1: -1393.7081,
    x2: -902.3999,
    y2: -1403.0431,
    gradientTransform: "matrix(19.2968 0 0 27.954 17447.9961 39187.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_377_00000173882934512106635950000005958314777989283718_)"
    },
    d: " M154.2,122.7c-0.5-0.2-0.8-0.8-0.7-1.4c0.5-1.5,0.2-3.5,0-5.2c-0.3-1.9-0.6-4.2-1.1-6.4l-0.2-0.8c-0.8-3.4-1.8-7.2,0-10.7 c0.4-0.7,0.9-1.4,1.4-2c1-1.1,2.5-1.6,3.9-1.2c2.4,0.7,4,3.9,4.4,5.9c0,0.2,0.1,0.5,0.1,0.7c0.2-0.2,0.3-0.3,0.4-0.4 c0.2-0.3,0.4-0.5,0.5-0.5c1.3-1.2,3.2-1.4,4.8-0.7c1.9,1,2.9,3,2.8,5.1c-0.3,4.7-4.5,8.1-8.6,11.3c-2.5,2-4.9,3.9-6.1,5.9 c-0.3,0.5-0.9,0.6-1.4,0.4C154.3,122.7,154.3,122.7,154.2,122.7L154.2,122.7z M164.6,102.3c-0.1,0.1-0.2,0.2-0.4,0.4 c-1.4,1.4-2.4,2.5-3.5,1.7c-0.8-0.6-0.9-1.7-1-2.7c0-0.2,0-0.3-0.1-0.5c-0.4-1.7-1.6-3.8-2.7-4.1c-0.2-0.1-0.7-0.2-1.5,0.6 c-0.4,0.4-0.8,0.9-1.1,1.5c-1.4,2.8-0.6,6.2,0.2,9.4l0.2,0.8c0.5,2.2,0.9,4.4,1.2,6.6c0.1,0.7,0.2,1.4,0.3,2.2 c1.2-1.2,2.6-2.3,4.1-3.5c3.8-3,7.6-6,7.9-9.9c0.1-1.2-0.4-2.3-1.4-2.9c-0.1,0-0.1-0.1-0.2-0.1 C165.9,101.6,165.1,101.8,164.6,102.3L164.6,102.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_378_00000085227086767818865800000013052432590206509485_",
    gradientUnits: "userSpaceOnUse",
    x1: -889.9042,
    y1: -1369.3867,
    x2: -904.3403,
    y2: -1399.3428,
    gradientTransform: "matrix(15.8177 0 0 8.7094 14151.2012 11969.5928)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_378_00000085227086767818865800000013052432590206509485_)"
    },
    d: " M145.7,136.3c-0.1-0.6,0.3-1.1,0.9-1.2l0,0c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.3-0.2,0.4-0.3c1-0.6,2-1.2,3.1-1.7 c3-1.7,6.2-3.1,9.4-4.2c0.6-0.2,1.3,0.1,1.6,0.6c0.2,0.5,0,1.1-0.5,1.4c0,0-0.1,0-0.1,0.1c-3.1,1.1-6.2,2.5-9.1,4.1 c-1,0.5-2,1.1-3,1.7c-0.1,0-0.1,0.1-0.2,0.1c-0.4,0.3-0.9,0.6-1.4,0.7c-0.2,0-0.4,0-0.5-0.1C146,137.1,145.7,136.8,145.7,136.3 L145.7,136.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_379_00000070832436933232924580000002593598311457096841_",
    gradientUnits: "userSpaceOnUse",
    x1: -878.3724,
    y1: -1379.4349,
    x2: -894.0175,
    y2: -1397.6979,
    gradientTransform: "matrix(14.5881 0 0 14.2855 12997.3086 19856.8652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_379_00000070832436933232924580000002593598311457096841_)"
    },
    d: " M155,132.1c1-0.8,1.6-2.6,2.2-3.7c1.5-2.6,3-5.4,5.5-7.2c1.2-1,2.8-1.6,4.3-1.5c1.3-0.1,2.4,0.9,2.5,2.2v0.1 c-0.1,0.9-0.5,1.7-1.1,2.3c-0.4,0.5-1.2,1-1.1,1.7s1,1.2,1.3,1.8c0.9,1.4,1.1,3.7-0.2,4.9c-2.2,2-5.6,1.1-8.4,0.7 C158.8,133.2,156.4,132.1,155,132.1L155,132.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_380_00000151506320534986786720000011075500904820650422_",
    gradientUnits: "userSpaceOnUse",
    x1: -887.8104,
    y1: -1384.3058,
    x2: -901.2823,
    y2: -1400.1449,
    gradientTransform: "matrix(16.9497 0 0 16.4628 15230.2734 22938.877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_380_00000151506320534986786720000011075500904820650422_)"
    },
    d: " M153.9,132.5c-0.2-0.4-0.1-0.9,0.3-1.2c0.6-0.7,1.1-1.4,1.4-2.3c0.2-0.4,0.4-0.8,0.5-1.1c1.7-3,3.3-5.6,5.8-7.6 c1.4-1.2,3.3-1.8,5.1-1.8c1,0,2,0.5,2.8,1.2c0.6,0.6,0.9,1.5,0.9,2.4c-0.1,1.1-0.6,2.1-1.3,2.9c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.2-0.4,0.4-0.5,0.6c0.1,0.2,0.3,0.3,0.4,0.5c0.3,0.3,0.5,0.5,0.7,0.9c1.1,1.9,1.3,4.7-0.4,6.2c-2.3,2.1-5.6,1.6-8.1,1.2 c-0.4-0.1-0.8-0.1-1.2-0.2c-0.8-0.1-1.6-0.4-2.4-0.6c-0.8-0.3-1.7-0.5-2.6-0.6c-0.2,0-0.3,0-0.5-0.1 C154.3,133,154,132.8,153.9,132.5L153.9,132.5z M167.1,120.8c-1.3,0-2.6,0.5-3.6,1.3c-2.2,1.7-3.7,4.1-5.3,6.9 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.2,0.5-0.5,1-0.7,1.5c0.4,0.1,0.9,0.3,1.3,0.4c0.6,0.2,1.3,0.4,1.9,0.5c0.4,0.1,0.8,0.1,1.2,0.2 c2.4,0.4,4.7,0.7,6.2-0.6c0.8-0.8,0.7-2.5,0-3.6c-0.1-0.1-0.2-0.3-0.4-0.4c-0.6-0.5-1-1.1-1.1-1.9c0-0.9,0.4-1.7,1.1-2.2 c0.1-0.1,0.2-0.2,0.2-0.2c0.4-0.5,0.7-1,0.8-1.7c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.1-0.3-0.3-0.5-0.3 C167.5,120.8,167.3,120.8,167.1,120.8L167.1,120.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_381_00000168839106651754088250000007715487356753113230_",
    gradientUnits: "userSpaceOnUse",
    x1: -777.8192,
    y1: -1373.6365,
    x2: -810.0621,
    y2: -1388.1575,
    gradientTransform: "matrix(7.0773 0 0 17.9785 5862.6074 25105.1172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_381_00000168839106651754088250000007715487356753113230_)"
    },
    d: " M126.3,156.3c0.4,0.2,0.9,0.1,1.2-0.3c1.1-1.4,1.9-2.9,2.4-4.6l0.2-0.5c1.5-4,2.4-7.5,2.4-11.4c0-0.6-0.5-1.1-1.2-1.2 c-0.6-0.1-1.1,0.4-1.2,1v0.1c-0.1,3.7-0.9,7.3-2.3,10.7l-0.2,0.5c-0.4,1.4-1,2.7-2,3.9c-0.4,0.4-0.4,1.1,0,1.5c0,0,0,0,0.1,0.1 C126,156.2,126.1,156.3,126.3,156.3L126.3,156.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_382_00000133511259765017608740000003538219682262187960_",
    gradientUnits: "userSpaceOnUse",
    x1: -873.215,
    y1: -1384.1779,
    x2: -888.829,
    y2: -1397.7659,
    gradientTransform: "matrix(14.6245 0 0 19.2034 13000.8389 26828.5879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_382_00000133511259765017608740000003538219682262187960_)"
    },
    d: " M130.2,146.6c0-0.3,1-1,1.2-1.2c1.2-1.2,2.4-2.3,3.5-3.6c2.6-3,4.5-8,3.5-12.1c-0.1-0.4-0.3-0.9-0.5-1.3c-1.3-2.4-3.8-0.2-4.5,1.3 c-0.2,0.4-0.4,1.2-0.8,1.4c-0.7,0.2-2-0.9-2.7-1c-2.2-0.3-4.4,0.8-5.4,2.8C122.4,137.5,127.9,142.9,130.2,146.6L130.2,146.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_383_00000116216708992566277700000014988407688732681136_",
    gradientUnits: "userSpaceOnUse",
    x1: -883.8709,
    y1: -1387.9226,
    x2: -897.309,
    y2: -1400.1156,
    gradientTransform: "matrix(16.9955 0 0 21.3999 15242.5908 29937.9297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_383_00000116216708992566277700000014988407688732681136_)"
    },
    d: " M129.2,147.1c-0.5-0.8-1.1-1.6-1.8-2.5c-2.7-3.6-6-8.1-4-12.3c1.2-2.5,3.9-3.8,6.6-3.4c0.5,0.1,1,0.3,1.4,0.6 c0.2,0.1,0.4,0.2,0.6,0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.2,0.1-0.3,0.2-0.4c0.6-1.1,2.2-2.9,4.1-2.9c1.1,0,2.1,0.7,2.5,1.7 c0.3,0.5,0.5,1,0.6,1.6c1.1,4.7-1,9.9-3.7,13c-0.9,1-1.9,2-2.8,2.9l-0.7,0.7c0,0-0.2,0.1-0.3,0.3s-0.5,0.4-0.6,0.6 c-0.1,0.3-0.4,0.6-0.7,0.7c-0.2,0.1-0.5,0.1-0.8,0C129.6,147.6,129.4,147.4,129.2,147.1L129.2,147.1z M136.4,128.5 c-0.5,0-1.5,0.9-2,1.7c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.8-0.7,1.4-1.4,1.6c-0.9,0.1-1.8-0.1-2.6-0.7c-0.2-0.1-0.4-0.2-0.7-0.3 c-1.7-0.2-3.3,0.7-4.1,2.2c-1.4,3.1,1.3,6.8,3.8,10.2c0.3,0.5,0.7,0.9,1,1.3l0,0c0.1-0.1,0.1-0.1,0.2-0.1l0.7-0.7 c0.9-0.9,1.9-1.8,2.7-2.8c2.3-2.6,4.3-7.3,3.3-11.2c-0.1-0.3-0.2-0.7-0.4-1C136.8,128.8,136.6,128.6,136.4,128.5 C136.5,128.5,136.4,128.5,136.4,128.5L136.4,128.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_384_00000170255294566111480990000016961804022040672151_",
    gradientUnits: "userSpaceOnUse",
    x1: -908.6613,
    y1: -1360.5145,
    x2: -919.5582,
    y2: -1411.9845,
    gradientTransform: "matrix(20.9496 0 0 5.0702 18972.9199 6847.7676)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_384_00000170255294566111480990000016961804022040672151_)"
    },
    d: " M113.2,164.9c-0.5-0.3-0.7-1-0.4-1.5l0,0c0.4-0.6,1.2-0.5,2-0.5h0.1c1.2,0,2.4,0,3.6-0.1c4.5-0.5,9-1.4,13.4-2.7 c0.6-0.2,1.3,0.2,1.5,0.7s-0.1,1.1-0.6,1.3h-0.1c-4.5,1.3-9.2,2.3-13.8,2.8c-1.2,0.1-2.5,0.2-3.9,0.1c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.4,0-0.5,0c-0.2,0.1-0.5,0.1-0.7,0C113.3,165,113.2,165,113.2,164.9L113.2,164.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_385_00000000188147991043295590000006588585582028102567_",
    gradientUnits: "userSpaceOnUse",
    x1: -894.0452,
    y1: -1383.3929,
    x2: -906.8243,
    y2: -1402.198,
    gradientTransform: "matrix(17.8685 0 0 13.8846 16071.8369 19322.4688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_385_00000000188147991043295590000006588585582028102567_)"
    },
    d: " M126.2,162.3c2.5-1.8,4.6-4.1,7-6c0.5-0.4,1.1-0.8,1.6-1.2c2.1-1.4,7.1-3.7,8.9-0.3c0.9,1.6-0.2,2.9-1.5,3.8 c-0.5,0.4-1.3,0.7-1.5,1.3c-0.3,0.8,0.4,1.4,0.6,2.1c0.4,0.9,0.5,2,0.1,3c-0.7,1.6-2.4,1.9-4.1,1.9 C133.9,166.8,129.2,164.1,126.2,162.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_386_00000059278055397433005920000015540251478443103907_",
    gradientUnits: "userSpaceOnUse",
    x1: -899.7907,
    y1: -1387.4091,
    x2: -911.0807,
    y2: -1403.65,
    gradientTransform: "matrix(20.2261 0 0 16.0693 18300.9258 22415.0273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_386_00000059278055397433005920000015540251478443103907_)"
    },
    d: " M125.6,163.2c-0.3-0.2-0.5-0.5-0.6-0.9c0-0.4,0.1-0.7,0.4-0.9c1.4-1.1,2.8-2.3,4.1-3.5c0.9-0.8,1.9-1.7,2.9-2.5 c0.6-0.5,1.2-0.9,1.7-1.3c0.4-0.3,4.4-2.9,7.8-2.1c1.2,0.3,2.3,1.1,2.9,2.2c0.6,1.1,1.1,3.1-1.8,5.2c-0.1,0.1-0.3,0.2-0.5,0.3 s-0.6,0.4-0.6,0.5s0,0.3,0.3,0.7c0.1,0.2,0.2,0.5,0.3,0.7c0.5,1.2,0.6,2.5,0.1,3.8c-0.9,2.2-3.4,2.5-5.1,2.5 c-1.4,0-2.8-0.3-4.1-0.8C130.7,166.1,128.1,164.7,125.6,163.2L125.6,163.2z M141.4,154.1c-1.5-0.4-4.1,0.6-5.8,1.8 c-0.5,0.3-1,0.7-1.5,1.2c-1,0.8-1.9,1.6-2.8,2.5c-1,0.9-2,1.8-3,2.7c2.7,1.5,6.4,3.5,9.1,3.5c1.8,0,2.7-0.4,3.1-1.3 c0.2-0.7,0.2-1.5-0.1-2.2c-0.1-0.2-0.1-0.3-0.2-0.5c-0.5-0.7-0.6-1.5-0.4-2.3c0.3-0.7,0.8-1.3,1.5-1.6c0.1-0.1,0.2-0.1,0.3-0.2 c1.8-1.3,1.4-2.2,1.2-2.5c-0.2-0.5-0.6-0.8-1.1-1C141.6,154.1,141.5,154.1,141.4,154.1L141.4,154.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_387_00000134931890727852448240000000203610781451631781_",
    gradientUnits: "userSpaceOnUse",
    x1: -781.1122,
    y1: -1377.9791,
    x2: -810.8752,
    y2: -1389.6682,
    gradientTransform: "matrix(7.6741 0 0 22.3314 6387.9258 31291.2207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_387_00000134931890727852448240000000203610781451631781_)"
    },
    d: " M87.1,182.8c0.5,0.2,1,0,1.3-0.3c2.9-3.6,4.7-8,5.2-12.5c0.5-2.8,0.4-5.8-0.4-8.6c-0.2-0.6-0.8-1-1.5-0.8 c-0.6,0.1-0.9,0.6-0.8,1.2v0.1c0.7,2.5,0.8,5.1,0.3,7.6c-0.5,4.2-2.2,8.2-4.8,11.6c-0.4,0.5-0.3,1.1,0.2,1.5c0,0,0,0,0.1,0 C86.8,182.7,87,182.7,87.1,182.8L87.1,182.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_388_00000012454006318005913150000016068908255151072411_",
    gradientUnits: "userSpaceOnUse",
    x1: -883.1024,
    y1: -1388.5897,
    x2: -896.1703,
    y2: -1399.5997,
    gradientTransform: "matrix(17.4378 0 0 23.7037 15621.6641 33220.0352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_388_00000012454006318005913150000016068908255151072411_)"
    },
    d: " M92,169.8c-0.3-0.8-0.6-1.5-1.1-2.2c-0.8-1.4-1.8-2.8-2.8-4.2c-2.1-3.1-3.6-6.5-4.3-10.2c-0.4-1.4-0.5-2.9-0.3-4.3 c0.3-1.6,2.7-3.3,4.5-2.7c1.1,0.5,1.9,1.3,2.4,2.4c0.4,0.7,0.7,1.4,0.9,2.2c0.1,0.2,0.2,0.7,0.5,0.8c0.7,0.2,1.7-0.9,2.2-1.2 c1.8-1.2,4-1.5,5.4,0.5c2.8,4.1,1,9.1-2,12.3C95.6,165.2,93.7,167.4,92,169.8L92,169.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_389_00000127749203536461694550000001482511210738432185_",
    gradientUnits: "userSpaceOnUse",
    x1: -891.1041,
    y1: -1391.3484,
    x2: -902.622,
    y2: -1401.4283,
    gradientTransform: "matrix(19.8047 0 0 25.8854 17859.5469 36308.2578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_389_00000127749203536461694550000001482511210738432185_)"
    },
    d: " M90.9,169.9c-0.2-0.5-0.4-1-0.7-1.4c-0.1-0.1-0.2-0.3-0.3-0.4c-0.5-0.9-1.1-1.8-1.7-2.6c-0.3-0.5-0.7-1-1-1.5 c-2.2-3.2-3.7-6.8-4.5-10.6v-0.2c-0.4-1.5-0.5-3-0.3-4.5c0.4-1.4,1.3-2.5,2.6-3.1c1-0.6,2.3-0.7,3.4-0.4c1.4,0.6,2.5,1.6,3.1,3 c0.4,0.7,0.7,1.3,0.9,2c0.2-0.1,0.4-0.3,0.5-0.4c0.2-0.1,0.4-0.3,0.5-0.4c1.3-0.9,2.8-1.3,4.3-1c1.1,0.3,2.2,1,2.8,1.9 c3.1,4.6,1.2,10.1-2.1,13.6c-1.9,2-3.7,4.2-5.4,6.5c-0.3,0.4-0.7,0.6-1.2,0.5c-0.1,0-0.1,0-0.2,0C91.3,170.6,91,170.3,90.9,169.9 L90.9,169.9z M97.4,150.5c-0.9-0.1-1.8,0.2-2.5,0.7c-0.1,0.1-0.2,0.2-0.3,0.2c-0.7,0.6-1.7,1.4-2.8,1.1c-0.7-0.2-1.3-0.8-1.4-1.6 c-0.2-0.7-0.5-1.3-0.8-2c-0.7-1.3-1.3-1.7-1.7-1.8c-0.5-0.1-1.1,0-1.5,0.3c-0.7,0.3-1.3,0.9-1.5,1.7c-0.1,1.3,0,2.6,0.3,3.8v0.2 c0.7,3.5,2.1,6.8,4.1,9.8c0.3,0.5,0.7,1,1,1.5c0.6,0.9,1.2,1.8,1.8,2.7l0.2,0.4v0.1c1.4-1.8,3.4-4.1,4.4-5.1c2.7-2.9,4.4-7.4,2-11 c-0.2-0.4-0.6-0.7-1-0.8C97.5,150.5,97.4,150.5,97.4,150.5L97.4,150.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_390_00000013915388704735599570000009521937185058477743_",
    gradientUnits: "userSpaceOnUse",
    x1: -916.6437,
    y1: -1388.8226,
    x2: -925.7587,
    y2: -1420.0717,
    gradientTransform: "matrix(25.0561 0 0 8.3545 22802.1992 11544.3467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_390_00000013915388704735599570000009521937185058477743_)"
    },
    d: " M58,214.1c0.3,0.1,0.7,0.1,1-0.1c5.7-3.5,13.5-5.6,22.1-6c0.6,0,1-0.5,1.1-1v-0.1c-0.1-0.6-0.7-1.1-1.3-1 c-9,0.4-17.2,2.7-23.3,6.3c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0.1,0.1,0.1C57.5,213.9,57.7,214.1,58,214.1L58,214.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_391_00000181800489552900990550000013672582310874682550_",
    gradientUnits: "userSpaceOnUse",
    x1: -901.618,
    y1: -1388.6418,
    x2: -912.879,
    y2: -1405.6147,
    gradientTransform: "matrix(20.2775 0 0 15.376 18295.7168 21479.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Trazado_391_00000181800489552900990550000013672582310874682550_)"
    },
    d: " M71.2,208.3c1.6-2.3,2.7-4.8,4.9-6.6c2.4-2,5.3-3.2,8.4-3.4c1.2-0.1,3,0.1,3.7,1.3c0.4,0.9,0.3,1.8-0.2,2.6 c-0.2,0.4-0.6,1-0.4,1.5c0.3,0.9,1.5,1.5,2.1,2.2c2,2.4,3.1,6.1-0.6,7.2c-0.8,0.2-1.6,0.4-2.4,0.4c-1.2,0.1-2.3,0.1-3.5,0 C78.8,213,75.1,209.7,71.2,208.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_392_00000132059916629771151190000005472410127234337175_",
    gradientUnits: "userSpaceOnUse",
    x1: -905.8577,
    y1: -1391.5435,
    x2: -915.9496,
    y2: -1406.4015,
    gradientTransform: "matrix(22.6251 0 0 17.5659 20515.3281 24579.6348)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_392_00000132059916629771151190000005472410127234337175_)"
    },
    d: " M75.3,211.5c-1.4-0.9-2.9-1.6-4.5-2.2c-0.3-0.1-0.6-0.4-0.7-0.7s-0.1-0.7,0.1-1c0.4-0.6,0.8-1.3,1.2-1.9c1-1.8,2.3-3.5,3.8-4.9 c2.6-2.1,5.7-3.4,9-3.7c2.3-0.2,4.1,0.5,4.9,1.9c0.5,1.1,0.5,2.5-0.1,3.6c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.4-0.2,0.4 c0.2,0.3,0.5,0.6,0.9,0.9c0.4,0.3,0.7,0.6,1,1c1.7,2.1,2.5,4.4,1.9,6.2c-0.5,1.4-1.6,2.4-3.1,2.7c-0.9,0.3-1.8,0.4-2.6,0.5 c-1.2,0.1-2.5,0.1-3.7,0c-0.9-0.1-1.8-0.3-2.6-0.6C78.6,213.3,76.9,212.5,75.3,211.5L75.3,211.5z M84.6,199.4 c-2.8,0.2-5.5,1.3-7.7,3.1c-1.4,1.3-2.5,2.8-3.4,4.4c-0.2,0.3-0.4,0.6-0.5,0.9c1.2,0.5,2.4,1.2,3.5,1.8c2.2,1.2,4.5,2.5,6.8,2.8 c1.1,0.1,2.1,0.1,3.2,0c0.7-0.1,1.5-0.2,2.2-0.4c0.7-0.1,1.4-0.7,1.6-1.4c0.3-1-0.3-2.7-1.5-4.2c-0.2-0.2-0.4-0.4-0.7-0.6 c-0.7-0.5-1.3-1.2-1.6-1.9c-0.2-0.7-0.1-1.4,0.3-2c0-0.1,0.1-0.2,0.1-0.2c0.3-0.5,0.4-1.1,0.2-1.7c-0.2-0.2-0.4-0.4-0.6-0.5 C85.8,199.4,85.2,199.3,84.6,199.4L84.6,199.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_393_00000002350721271477575770000017705056050635329929_",
    gradientUnits: "userSpaceOnUse",
    x1: -932.0426,
    y1: -1408.2251,
    x2: -935.4086,
    y2: -1412.6641,
    gradientTransform: "matrix(67.8321 0 0 58.7837 63363.1406 82914.5312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4D1A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#DEC68C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C8A244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "url(#Trazado_393_00000002350721271477575770000017705056050635329929_)"
    },
    d: " M200.3,223.5c0.3,0.1,0.5,0.2,0.8,0.2c3.6,0.6,8.4-0.1,9.9-3.6c0.9-2.1,0.3-4.4-1.7-6.4c-0.3-0.3-1-1-11.2-5.6 c-0.8-0.4-1.6-0.7-2.3-1.1c2.9,0.4,6.8,0.8,12,1.4c2.7,0.3,4.9,0.6,5.2,0.6c2.9,0.8,5.8-1,6.6-3.8c0-0.1,0-0.2,0.1-0.2 c1-4.5-1.5-9-5.8-10.4h-0.1c-3.5-1.2-6.2-0.6-18.7,2.6c7.6-4.3,15-10.4,12.6-16.8c-1.1-3-4.6-6.7-8.4-7.5 c-2.2-0.6-4.5,0.1-6.1,1.7c-1.7,2-3.1,4.1-4.2,6.5c1.4-5.7,1.5-9.9,0.2-12.5c-0.6-1.3-1.7-2.3-3-2.9c-2.6-1-6.3-1.2-9,3.1 c-2.7,4.2-3.6,11.3-3.8,16.5c0,0.7-0.1,1.4-0.1,2c-2.8-7.5-7.8-17.9-13.5-19.8c-0.1,0-0.1,0-0.2-0.1c-2.2-0.7-4.5-0.1-6.1,1.6 c-1,1-1.5,2.4-1.4,3.8c0.4,8.4,16.7,23.4,18.6,25c0.5,0.4,1.2,0.4,1.7,0c0.4-0.4,0.4-1.1,0-1.5c0,0-0.1,0-0.1-0.1 c-6-5.5-17.6-17.4-17.8-23.5c-0.1-0.8,0.2-1.6,0.8-2.2c1.7-1.6,3.1-1.3,4-1c6.3,2.6,12.9,20.5,14,25.2c0.1,1.5,0.2,1.7,0.5,1.9 c0.4,0.4,1,0.4,1.5,0.1c0.6-0.5,0.5-1.2,0.3-1.9v-0.1c-0.3-4.4-0.5-22.4,5.2-26.6c1.3-0.9,3.1-1.1,4.6-0.4 c0.8,0.3,1.4,0.9,1.7,1.6c1.1,2.3,1.8,9-6.2,27.5c-0.5,1.2-0.7,1.7,0,2.2c0.4,0.3,1,0.3,1.4,0.1c0.8-0.5,1.7-2.3,4.2-7.7 c2.6-5.4,6.1-12.9,8.5-15.3c1-1.1,2.5-1.5,3.9-1.1c2.9,0.7,5.7,3.6,6.6,6c2.4,6.4-9.4,14-21.3,19c-0.3,0.1-1.3,0.5-0.9,1.5 c0.3,0.5,0.9,0.8,1.5,0.7c3-0.8,5.6-1.4,7.9-2.1c14.3-3.7,17.3-4.5,20.4-3.5h0.1c3.2,1.1,5,4.4,4.3,7.7c-0.3,1.8-2,2.9-3.7,2.6 c-0.1,0-0.2,0-0.3-0.1c-0.2,0-1.3-0.2-5.4-0.7c-6-0.7-18.6-2.2-19.8-2.5c-0.5-0.2-0.7-0.1-0.9,0c-0.5,0.2-0.8,0.7-0.7,1.2 c0.1,0.3,0.1,0.6,0.8,0.8l0,0l0,0c1.5,0.6,18.9,8.2,20.3,9.4c1.3,1.4,1.8,2.7,1.2,4.1c-1,2.4-4.6,2.7-7.4,2.3 c-2.1-0.3-7-5-10.2-8.1c-1.5-1.5-3.1-3-4.9-4.3c-0.5-0.3-1.2-0.2-1.6,0.3c-0.3,0.5-0.2,1.2,0.3,1.5c0,0,0,0,0.1,0 c1.6,1.2,3.1,2.5,4.4,3.9C194,219.2,197.6,222.6,200.3,223.5L200.3,223.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    style: {
      clipPath: "url(#SVGID_00000139252289439843173950000000965903684981187205_)",
      fill: "none",
      stroke: "#724F2B",
      strokeWidth: 0.93,
      strokeMiterlimit: 10
    },
    d: " M793.7,27.9c-41.4-30.5-101.4-19-130.7,25s-24,114.4,11.8,153.4c8.2,8.9,18.2,16.5,29.4,17.2s23-7.5,24.5-20.2 c2.2-18-17.6-31.7-32.8-27.2s-25.7,20.1-34.4,35.1c-24.7,42.7-44.7,89.1-72.1,129.4s-64.3,75.2-108.4,83.7s-95.4-16-112.2-64.5 c-3.5-10-2.1-25.9,7.1-25.7c9.6,0.3,10.3,17.4,5.3,26.8c-16,30.5-51.5,39.5-82.5,34.9s-60.3-19.8-91-26.5 C134,353,54.5,391.1,13.4,462.2"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000067925538092502390390000010216120789286777236_)",
      fill: "none"
    },
    width: 779.7,
    height: 312.1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000067925538092502390390000010216120789286777236_)",
      fill: "none"
    },
    width: 781,
    height: 312.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.3deccb64ac8d2d571772d1f2f21bae73.svg";
export { ForwardRef as ReactComponent };